<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="backButtonRoute ? true : false"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
    :tabs="[]"
    :selectedIndex="undefined"
    ref="gc-base-layout"
  >
    <slot> </slot>
    <template #headerContent>
      <GcHeaderContentDynamic
        :title="getScreenJson.title"
        :createModeIsEditMode="getHeaderScreenJson.title.createModeIsEditMode"
        :baseView="baseView"
        :primaryLabel="
          baseView.mode == 'create'
            ? 'Create Purchase Order'
            : 'Purchase Order # ' + baseView.id
        "
        :secondaryLabel="
          baseView.mode == 'review' || baseView.mode == 'edit'
            ? model.SupplierName
            : undefined
        "
        v-if="loaded"
      />
    </template>

    <div v-if="loaded" class="purchase-order css-v2 transaction-screen">
      <div class="gc-header-toolbar">
        <gc-form-header-toolbar
          :toolbar-options="getHeaderToolbar"
          :data-model="loaded ? model : {}"
          :itemSaveCallBack="saveTransaction"
          :backRoute="backButtonRoute"
          :setLoading="showLoading"
          ref="gc-form-header-toolbar"
          :baseView="baseView"
        ></gc-form-header-toolbar>
      </div>
      <div class="gc-header-form" v-show="!gridExpand">
        <div class="header-form-container">
          <div class="header-form">
            <div class="view-card responsive-paddings">
              <gc-form
                :formOptions="{
                  gcLabelLocation: 'left',
                }"
                :formItems="getHeaderFormItems"
                :isNormal="true"
                :data-model="loaded ? model : {}"
                :deliveryAddressClicked="showDeliveryAddress"
                :formMode="baseView.mode"
                :fromFrom="'gc-header-form'"
                ref="gc-header-form"
                :checkValid="isValid"
                :validationGroup="'gc-header-form'"
                :scrollingEnabled="false"
                :formContentReady="onHeaderFormContentReady"
                :formHeight="100"
              ></gc-form>
            </div>
          </div>

          <div class="header-comments">
            <div class="view-card responsive-paddings">
              <gc-form
                :formOptions="{
                  gcLabelLocation: 'left',
                }"
                :formItems="getCommentPopUpItems"
                :isNormal="true"
                :data-model="loaded ? model : {}"
                :deliveryAddressClicked="undefined"
                :formMode="baseView.mode"
                :fromFrom="'gc-header-comments'"
                ref="gc-header-comments"
                :checkValid="isValid"
                :validationGroup="'gc-header-comments'"
                :scrollingEnabled="true"
                :formHeight="100"
              ></gc-form>
            </div>
          </div>
        </div>
      </div>

      <div class="gc-data-grid-so-v5">
        <dx-tooltip :ref="tooltipRefName" position="top">
          <div class="tooltipContent">
            <div>
              Update Supplier's Unit Price based upon the price in this Purchase
              Order
            </div>
          </div>
        </dx-tooltip>
        <dx-data-grid
          @cell-prepared="onCellPrepared"
          :data-source="getLocalDataSource"
          :columns="getColumns"
          :height="getGridHeight"
          :column-chooser="{ enabled: false }"
          :ref="'dx-data-grid-comp'"
          :key-expr="'ID'"
          :repaint-changes-only="true"
          :show-borders="true"
          :two-way-binding-enabled="false"
          :focusedRowEnabled="true"
          @toolbar-preparing="onToolbarPreparing($event)"
          @content-ready="onContentReady"
          @option-changed="onOptionChanged"
          @saved="onSaved"
          @editor-preparing="onEditorPreparing"
          v-if="loaded"
          @editing-start="onEditingStart"
          @row-updated="onRowUpdated"
          @row-removed="onRowRemoved"
        >
          <DxEditing
            :allow-deleting="baseView.mode != 'review'"
            :allow-updating="baseView.mode != 'review'"
            :mode="'cell'"
            :changes="changes"
          />

          <DxKeyboardNavigation
            :edit-on-key-press="true"
            :enter-key-action="'startEdit'"
            :enter-key-direction="'none'"
            :enabled="true"
          />

          <DxPaging :page-size="200" :enabled="false" />

          <DxPager
            :showInfo="true"
            :showPageSizeSelector="false"
            :infoText="'({2} items)'"
            :visible="false"
            class="gc-pager"
            cssClass="gc-pages-2"
          />

          <template #product-code-edit-template="{ data: cellInfo }">
            <DxAutocomplete
              :data-source="productDataSourceItems"
              :showDropDownButton="true"
              :valueExpr="'ProductCode'"
              :displayValue="'ProductCode'"
              :searchExpr="[
                'ProductCode',
                'ProductDescription1',
                'PurchaseDescription1',
              ]"
              :dropDownOptions="{
                width: 250,
              }"
              @value-changed="
                (e) => {
                  cellInfo.setValue(e.value);
                  productCodeValueChanged(e, cellInfo);
                }
              "
              @focus-in="productCodeFocusIn"
            >
              <template #item="{ data }">
                <div class="custom-auto-complete">
                  <div :id="data.ProductCode">
                    <span class="auto-complete-primary">
                      {{ data.ProductCode }}
                    </span>
                    <span class="record-secondary gc-grid-code">
                      {{ data.PurchaseDescription1 }}
                    </span>
                  </div>
                </div>
              </template>
            </DxAutocomplete>
          </template>

          <template #account-code-edit-template="{ data: cellInfo }">
            <DxAutocomplete
              :data-source="glChartDataSourceItems"
              :showDropDownButton="true"
              :valueExpr="'ComputedStringCode'"
              :displayValue="'ComputedStringCode'"
              :searchExpr="[
                'ComputedStringCode',
                'Description',
                'ParentGLChartDescription',
              ]"
              :dropDownOptions="{
                width: 250,
              }"
              @value-changed="
                (e) => {
                  cellInfo.setValue(e.value);
                  productCodeValueChanged(e, cellInfo);
                }
              "
              @focus-in="productCodeFocusIn"
            >
              <template #item="{ data }">
                <div class="custom-auto-complete">
                  <div :id="data.ComputedStringCode">
                    <span class="auto-complete-primary">
                      {{ data.ComputedStringCode }}
                    </span>
                    <span class="record-secondary gc-grid-code">
                      {{ data.Description }}
                    </span>
                  </div>
                </div>
              </template>
            </DxAutocomplete>
          </template>

          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>
          <template #DecimalCell="{ data }">
            <GcDecimalCell :dataValue="data" :format="data.column.format" />
          </template>

          <template #sup-price-header-template>
            <div>
              <!-- :hint="`Update Supplier's Unit Price based upon the price in this Purchase Order`" -->
              <DxCheckBox
                :ref="'sup-price-header-template'"
                :on-value-changed="onSupPriceHeaderUpdate"
                :disabled="dataGridViewType == 'review'"
              />
            </div>
          </template>

          <template #sup-price-template="{ data: cellInfo }">
            <div>
              <!-- :hint="`Update Supplier's Unit Price based upon the price in this Purchase Order`" -->
              <DxCheckBox
                :value="cellInfo.data.UpdateSupplierPrice"
                :on-value-changed="
                  (e) => {
                    if (cellInfo.setValue) cellInfo.setValue(e.value);
                    if (e.event) onUpdateSupplierPriceChanged(e);
                  }
                "
                :disabled="dataGridViewType == 'review'"
              />
            </div>
          </template>
        </dx-data-grid>
      </div>

      <GcFooter v-if="showFooter && loaded">
        <template #leftContent>
          <div
            class="gc-grid-footer-item left-content"
            v-for="item in footerLeftItems"
            :key="item.label"
          >
            <label class="gc-footer-label">{{ item.label }}</label>

            <label
              v-if="item.fieldType == 'custome-string'"
              class="gc-footer-value"
              >{{ item.value }}</label
            >
            <GcFooterItem
              :value="item.value"
              :format="item.format"
              :length="item.format == 'Decimal-16-4C' ? 8 : 4"
              v-else
            />
          </div>
        </template>
        <template #rightContent>
          <div
            class="gc-grid-footer-item"
            v-for="item in footerRightItems"
            :key="item.label"
          >
            <label class="gc-footer-label">{{ item.label }}</label>
            <GcFooterItem
              :value="item.value"
              :format="item.format"
              :length="item.format == 'Decimal-16-4C' ? 8 : 6"
            />
          </div>
        </template>
      </GcFooter>
    </div>

    <!-- Search Products PopUp -->
    <DxPopup
      :visible="visibleSearchProducts"
      :drag-enabled="true"
      :hide-on-outside-click="false"
      :show-title="true"
      :width="'75%'"
      :height="690"
      :title="'Search Products'"
      @hidden="popupHidden"
      :showCloseButton="false"
      :wrapper-attr="{ class: 'search-products-popup css-v2 gc-popup' }"
    >
      <div class="search-products">
        <div style="background-color: white">
          <DxTabs
            :width="dataGridViewType == 'product-entry' ? 500 : 250"
            :data-source="searchProductsTabs"
            :selected-index.sync="searchProductsSelectedIndex"
            :keyExpr="'id'"
          />
        </div>
        <div class="css-v2 transaction-list">
          <dx-tooltip :ref="tooltipRefName" position="top">
            <div class="tooltipContent">
              <div>
                Update Supplier's Unit Price based upon the price in this
                Purchase Order
              </div>
            </div>
          </dx-tooltip>
          <dx-data-grid
            v-if="visibleSearchProducts"
            :data-source="searchProductsDataSource"
            :columns="searchProductsColumns"
            :height="550"
            :columnChooser="{
              enabled: false,
            }"
            @cell-prepared="onCellPrepared"
            :onRowDblClick="onSearchProductsRowDblClick"
          >
            <DxPaging :page-size="20" :enabled="true" />

            <DxPager :visible="false" />

            <DxScrolling
              :mode="'virtual'"
              :row-rendering-mode="'virtual'"
              :preloadEnabled="true"
            />
          </dx-data-grid>
        </div>
      </div>

      <div class="footer edit-product-item-popup-footer">
        <DxButton
          text="Cancel"
          type="default"
          styling-mode="contained"
          class="cancel-btn"
          @click="popupHidden"
        />
      </div>
    </DxPopup>

    <!-- Delivery Address -->
    <gc-popup
      v-if="editDeliveryAddressVisible"
      :popup-visible="editDeliveryAddressVisible"
      popup-title="Deliver To"
      :back-button-function="closeDeliveryAddressPopup"
      :popup-height="375"
      :saveButtonConfig="deliveryAddressPopupConfig.save"
      :backButtonConfig="deliveryAddressPopupConfig.back"
      :wrapperAttr="{ class: 'css-v2 gc-popup' }"
    >
      <div class="css-v2 gc-popup-form po-dl">
        <gc-form
          :formOptions="{
            gcLabelLocation: 'left',
          }"
          :formItems="getDeliverToFormItems"
          :isNormal="true"
          :data-model="addressData"
          :formMode="baseView.mode"
          :fromFrom="'gc-header-form-d-a'"
          :formHeight="240"
        ></gc-form>
      </div>
    </gc-popup>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import {
  getDefaultUserSettings,
  // getDefaultCustomerSettings,
  // getDefaultUserSettings,
  getFactorByCode,
  getGlobalField,
} from "../../_store/helpers";
import { mapGetters } from "vuex";
import { CompanyCurrencyService } from "../../_services/api/accounts/company-currency.service";
import { BranchService } from "../../_services/api/sales/branch.service";
import { CompanyService } from "../../_services/api/accounts/company.service";
import { DivisionService } from "../../_services/api/sales/division.service";
import { formatNumber } from "devextreme/localization";
import SettingsService from "../../_services/api/settings/graycorp/settings.service";
import { TaxCategoryService } from "../../_services/api/settings/accounting/tax-category.service";
import { CommonStorage, FeatureStorage } from "../../_services/storage";
import { ProductService } from "../../_services/api/products/product.service";
import ArrayStore from "devextreme/data/array_store";
import validationEngine from "devextreme/ui/validation_engine";
import { PurchaseOrder } from "../../_services/api/purchasing/purchase-order.service";
import { PurchaseOrderDetail } from "../../_services/api/purchasing/purchase-order-detail.service";
import { GoodsInService } from "../../_services/api/purchasing/goods-in.service";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";

import CheckBox from "devextreme/ui/check_box";
import { ForeignCurrencyService } from "../../_services/api/settings/accounting/foreign-currency.service";
import { custom } from "devextreme/ui/dialog";

import DxTooltip from "devextreme-vue/tooltip";
import { on } from "devextreme/events";

const productEntryBase = {
  ID: 1,
  Code: undefined,
  Description: undefined,
  Inactive: "N",
  BranchCode: undefined,
  BranchDescription: undefined,
  DivisionCode: undefined,
  DivisionDescription: undefined,
  RequiredByDate: undefined,
  ETADate: undefined,
  SupplierUM: undefined,
  SupplierRequired: 0,
  SupplierReceivedQty: 0,
  IsBatchProduct: "No",
  SupplierFXPrice: 0,
  FXLineTotal: 0,
  ItemCode: undefined,
  ItemDescription: undefined,
  ItemType: undefined,
  TaxableFXLineTotal: 0,
  TaxFXLineTotal: 0,
  FXTotal: 0,
  FXIncTaxLineTotal: 0,
  LineNo: 0,
  SupplierConversion: 1,
  SupplierPrice: 0,
  TaxPcnt: 0,
  IsVariable: "N",
  IsCopyLine: false,
  // CopyCode: undefined,
  TaxCode: undefined,
  Comment: "",
  IsGLEntry: false,
  isNewRecord: true,
  UpdateSupplierPrice: false,
  SupplierPriceEdited: false,
};

const modelBase = {
  ContainsManualBatch: false,
  Authorised1: "",
  Authorised2: "",
  AuthorisedBy: "",
  AutoGenerated: "",
  B2BSupplierReferenceNo: "",
  ChangedBy: "",
  Code: "",
  Comment1: "",
  Comment2: "",
  Comment3: "",
  Comment4: "",
  Comment5: "",
  Confirmed: "",
  CreatedBy: "",
  CurrencyCode: "",
  DateAuthorised: "",
  DateIn: new Date(),
  DateInto: null,
  DateChanged: "",
  DeliveryAddressCompanyName: null,
  DeliveryAddressCountry: null,
  DeliveryAddressPostcode: "",
  DeliveryAddressState: "",
  DeliveryAddressStreetLine1: "",
  DeliveryAddressStreetLine2: "",
  DeliveryAddressSuburb: "",
  DeliveryInstruction1: "",
  DeliveryInstruction2: "",
  DeliveryMonth: "",
  ExchangeRate: "",
  GoodsReceived: false,
  Name: "",
  NextStatus: "",
  Note: "",
  ProcessStatus: "",
  RecordId: "",
  Status: "C",
  SupplierCode: undefined,
  SupplierName: undefined,
  View: "",
  GoodsIn: false,
  Supplier: {
    Code: "",
    CurrencyCode: "",
    Fax1: "",
    InternationalFax: "",
    InternationalPhone: "",
    MailAddressCountry: "",
    MailAddressPostcode: "",
    MailAddressState: "",
    MailAddressStreetLine1: "",
    MailAddressStreetLine2: "",
    MailAddressSuburb: "",
    Name: "",
    Phone1: "",
    PhysicalAddressCountry: "",
    PhysicalAddressPostcode: "",
    PhysicalAddressState: "",
    PhysicalAddressStreetLine1: "",
    PhysicalAddressStreetLine2: "",
    PhysicalAddressSuburb: "",
    Status: "",
    SupplierTypeCode: "",
    WithholdingTaxRate: "",
  },
  CompanyCurrency: "",
  BranchCode: undefined,
  DivisionCode: undefined,
  BranchChanged: false,
  DivisionChanges: false,
  DeliverTo: undefined,
};

function countLineBreaks(text) {
  return (text.match(/\n/g) || []).length;
}

export default {
  mixins: [RouteMixin, FormMixin],
  components: { DxTooltip },
  data() {
    return {
      tooltipRefName: "tooltip",
      model: { ...modelBase },

      loaded: false,
      branchPlaceHolder: "Select",
      divisionPlaceHolder: "Select",

      cancelCompleteMenu: [],

      defaultDataModel: {
        DefaultBranchCode: null,
        DefaultDivisionCode: null,
        DefaultBranchDescription: null,
        DefaultDivisionDescription: null,
        ETADate: undefined,
      },
      branchDataSourceItems: [],
      divisionDataSourceItems: [],
      showFooter: true,
      footerItems: [],

      dataSourceProductEntry: new ArrayStore({
        key: "ID",
        data: [],
      }),
      dataSourceGLEntry: new ArrayStore({
        key: "ID",
        data: [],
      }),
      dataGridViewType: "product-list",
      // dataGridViewType: "gl-entry",
      screenSettings: [],
      productDataSourceItems: [],
      glChartDataSourceItems: [],
      defaultVisible: {},
      brokenGridValidations: [],
      taxCodeDataSourceItems: [],

      validationLineKey: undefined,
      validationDataField: undefined,
      changes: [],
      visibleSearchProducts: false,
      searchProductsSelectedIndex: 0,
      selectedProduct: undefined,
      contentReady: false,

      isValid: false,
      editDeliveryAddressVisible: false,
      addressData: undefined,
      headerFormHeight: 0,
      orderCommentModel: {},

      dataSourceProductList: new ArrayStore({
        key: "ID",
        data: [],
      }),

      dataSourceReview: new ArrayStore({
        key: "ID",
        data: [],
      }),
    };
  },

  async created() {
    this.showLoading(true);

    this.$store.dispatch("reportPdfPreview/setReportPreviewScreens");
    // this.$store.dispatch("dataContext/setDataViewType", "general-ledger");

    this.setBranchDataSourceItems();
    this.setDivisionDataSourceItems();
    this.setTaxCodeDataSourceItems();
    // this.setGLChartDataSourceItems();
    this.beforeInit();
  },
  async mounted() {},
  beforeDestroy() {
    this.$store.dispatch("dataContext/setSearchText", undefined);
  },
  watch: {
    dataSourceProductEntry: {
      handler(val) {
        this.dataSourceReview.clear();
        let data = this.dataSourceProductList._array.filter(
          (x) => x.SupplierRequired,
        );
        let dataEntry = val._array.filter(
          (x) => x.ItemCode && x.SupplierRequired,
        );

        data
          .concat(dataEntry)
          .concat(this.dataSourceGLEntry._array)
          .forEach((element) => {
            this.dataSourceReview.insert(element);
          });
        this.setFooterItems(this.dataSourceReview._array);

        if (this.loaded && this.$refs["dx-data-grid-comp"])
          this.checkMultipleBranchDivision();
      },
      deep: true,
    },
    dataSourceGLEntry: {
      handler(val) {
        this.dataSourceReview.clear();
        let data = this.dataSourceProductList._array.filter(
          (x) => x.SupplierFXPrice && x.SupplierRequired,
        );
        data
          .concat(this.dataSourceProductEntry._array)
          .concat(val._array)
          .forEach((element) => {
            this.dataSourceReview.insert(element);
          });
        this.setFooterItems(this.dataSourceReview._array);
        if (this.loaded && this.$refs["dx-data-grid-comp"])
          this.checkMultipleBranchDivision();
      },
      deep: true,
    },
    dataSourceProductList: {
      handler(val) {
        if (this.dataGridViewType == "product-list") {
          this.dataSourceReview.clear();
          let data = val._array.filter((x) => x.SupplierRequired);

          let dataEntry = this.dataSourceProductEntry._array.filter(
            (x) => x.ItemCode && x.SupplierRequired,
          );

          data
            .concat(dataEntry)
            .concat(this.dataSourceGLEntry._array)
            .forEach((element) => {
              this.dataSourceReview.insert(element);
            });

          this.setFooterItems(this.dataSourceReview._array);
          if (this.loaded && this.$refs["dx-data-grid-comp"])
            this.checkMultipleBranchDivision();
        }
      },
      deep: true,
    },
    async getValidationSummaryVisible(val) {
      if (!val && this.validationLineKey == "Suppiler") {
        if (this.gridExpand) await this.expandGrid();
        this.validationLineKey = undefined;
        var headerToolBarForm =
          this.$refs["gc-form-header-toolbar"].$refs["toolbar-form"].$refs[
            "gc-form-comp"
          ].instance;
        if (headerToolBarForm) {
          headerToolBarForm.getEditor("SupplierCode").focus();
          var supDropdown = headerToolBarForm
            .getEditor("SupplierCode")
            .instance();
          supDropdown.open();
        }
      }

      if (!val && this.validationLineKey) {
        if (this.gridExpand) await this.expandGrid();
        const column = this.validationLineKey;
        this.focusOnEditableCell(this.validationDataField, column);
        this.validationLineKey = undefined;
      }
    },
    dataGridViewType() {
      this.checkBranchSpecs();
    },
  },
  beforeRouteLeave(to, from, next) {
    var splitTo = to.fullPath.split("/");

    if (splitTo[splitTo.length - 1] == "create") {
      this.refreshView();
      this.beforeInit();
    }

    next();
  },
  computed: {
    ...mapGetters({ commentPopUpItems: "ui/getCommentPopUpItems" }),
    ...mapGetters({ gridHeight: "ui/getHeightForDataGrid" }),
    ...mapGetters({ gridExpand: "ui/getGridExpand" }),
    ...mapGetters({
      getValidationSummaryVisible: "ui/getValidationSummaryVisible",
    }),
    getScreenJson() {
      var screenJson = {
        title: "Purchase Order",
      };
      return screenJson;
    },
    getCommentPopUpItems() {
      return [
        {
          itemType: "group",
          caption: "",
          items: [
            {
              dataField: "DeliveryInstruction1",
              label: { text: "Delivery 1" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
              },
            },
            {
              dataField: "DeliveryInstruction2",
              label: { text: "Delivery 2" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
              },
            },
            {
              dataField: "Comment1",
              label: { text: "Comment 1" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
              },
            },
            {
              dataField: "Comment2",
              label: { text: "Comment 2" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
              },
            },
            {
              dataField: "Comment3",
              label: { text: "Comment 3" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
              },
            },
            {
              dataField: "Comment4",
              label: { text: "Comment 4" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
              },
            },
            {
              dataField: "Comment5",
              label: { text: "Comment 5" },
              editorType: "dxTextBox",
              editorOptions: {
                maxLength: 100,
                onKeyDown: this.onComment5KeyDown,
              },
            },
          ],
        },
      ];
    },
    getHeaderToolbar() {
      return {
        screenName: "Purchase Orders Review",
        email: this.baseView.mode == "review",
        audit: this.baseView.mode == "review",
        editURL: `/${this.getScreenPath()}`,
        editCallBack: () => {
          this.refreshView();
          this.beforeInit();
        },
        status: true,
        notes: false,
        pdf: this.baseView.mode == "review",
        //  copy: this.baseView.mode == "review",
        //  copyCallBack: this.copyPurchaseOrder,
        save: this.model.Status !== "C" && this.model.Status !== "X",
        saveOptions: {
          items: [
            { text: "Draft", value: "D", disabled: this.model.Status == "A" },
            { text: "Save", value: "A", default: true },
          ],
          keyExpr: "value",
          displayExpr: "text",
          dropDownOptions: {
            width: "100px",
          },
          saveKey: "NextStatus",
        },
        saveCallback: this.saveData,
        notesDropDownOptions: {
          width: 170,
        },
        toolbarFormItems: [
          {
            screenField: "Supplier",
            dataField: "SupplierCode",
            cssClass: "toolbar-customer-label",
            editorOptions: {
              dropDownOptions: {
                minWidth: 300,
              },
              width: 300,
              placeholder: "Supplier Name",
              onValueChanged: async (e) => {
                if (!e.event) return;

                var items = e.component.getDataSource().items();
                var item = items.filter((x) => x.Code == e.value);

                var productItems = this.dataSourceProductEntry._array.filter(
                  (p) => p.ItemCode,
                );
                var glItems = this.dataSourceGLEntry._array.filter(
                  (gl) => gl.ItemCode,
                );

                if (productItems.length > 0 || glItems.length > 0) {
                  let confirmSupplierChange = await this.$confirm(
                    "Changing the supplier will clear all items currently list in the grid. Do you want to proceed ?",
                    "Confirm Supplier Change",
                  );

                  if (!confirmSupplierChange) {
                    e.component.beginUpdate();
                    e.component.option("value", e.previousValue);
                    e.component.endUpdate();

                    return;
                  } else {
                    this.showLoading(true);
                    this.onSupplierItemClick({
                      itemData: item[0],
                    });
                    this.$nextTick(async () => {
                      await this.getProductPurchaseList(e.value);
                    });
                    this.showLoading(false);
                  }
                } else {
                  this.showLoading(true);
                  this.onSupplierItemClick({
                    itemData: item[0],
                  });
                  this.$nextTick(async () => {
                    await this.getProductPurchaseList(e.value);
                  });
                  this.showLoading(false);
                }
              },
              showClearButton: true,
              // onItemClick: this.onSupplierItemClick.bind(this),
            },
            label: {
              text: "Supplier",
              visible: false,
            },
            required: true,
          },
        ],
        formContentReady: (e) => {
          if (e && this.baseView.mode == "create" && this.loaded)
            setTimeout(() => {
              var headerToolBarForm = e.component;
              if (
                headerToolBarForm &&
                headerToolBarForm.getEditor("SupplierCode")
              )
                headerToolBarForm.getEditor("SupplierCode").instance().focus();
            }, 500);
        },
        emailMenuItems: {
          referenceNoField: "Code",
          makeDisabled: (dataModel, emailRecords) => {
            var items = [];

            emailRecords.forEach((element) => {
              items.push({
                ReportDisplayName: element.ReportDisplayName,
                ScreenName: element.ScreenName,
                ScreenLayoutApplicationFeatureCode:
                  element.ScreenLayoutApplicationFeatureCode,
                TransactionCode: element.TransactionCode,
                disabled: element.disabled,
              });
            });

            return items;
          },
        },
        auditItems: [
          {
            itemType: "group",
            caption: "",
            items: [
              {
                dataField: "FormattedDateCreated",
                label: { text: "Created By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  // // disabled: true,
                },
              },
              {
                dataField: "FormattedDateChanged",
                label: { text: "Changed By", location: "left" },
                editorType: "dxTextBox",
                editorOptions: {
                  // disabled: true,
                },
              },
            ],
          },
        ],

        ellipsis: {
          menuItems: this.cancelCompleteMenu,
          visible: this.baseView.mode == "review",
          clickAction: (e) => {
            if (e.itemData.menuText == "Cancel Order") {
              this.cancelOrder();
            } else if (e.itemData.menuText == "Copy") {
              this.copyOrder();
            } else {
              this.completeOrder();
            }
          },
          disabled:
            !FeatureStorage.checkPermission("PurchaseOrder", "create") ||
            this.cancelCompleteMenu.length == 0,
        },
      };
    },
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  itemType: "group",
                  caption: "",
                  colCount: this.baseView.mode != "create" ? 2 : 1,
                  items: [
                    {
                      screenField: "DateIn",
                      editorOptions: {
                        useMaskBehavior: true,
                        onFocusIn: (e) => {
                          e.event.target.select();
                        },
                        onValueChanged: this.onDateInValueChanged.bind(this),
                        readOnly: this.model.GoodsIn,
                        tabIndex: this.model.GoodsIn ? -1 : undefined,
                      },
                      required: this.baseView.mode != "review",
                    },
                    {
                      screenField: "ETADate",
                      label: {
                        text: "ETA",
                      },
                      dataField: "ETA",
                      editorOptions: {
                        min: new Date(),
                        onValueChanged: this.onETAValueChanged.bind(this),
                        tabIndex:
                          this.dataGridViewType == "review" ? -1 : undefined,
                        readOnly: this.dataGridViewType == "review",
                      },
                      visible: this.baseView.mode != "create",
                    },
                  ],
                },
                {
                  screenField: "SupplierRef",
                  editorOptions: {
                    maxLength: 20,
                  },
                },
                {
                  itemType: "group",
                  caption: "",
                  colCount: 2,
                  items: [
                    {
                      screenField: "Currency",
                      allowUpdate: false,
                      editorOptions: {
                        tabIndex: -1,
                      },
                    },
                    {
                      screenField: "ExchangeRate",
                      editorOptions: {
                        readOnly:
                          this.model.CompanyCurrency ===
                            this.model.CurrencyCode ||
                          this.model.Status === "C" ||
                          this.model.Status === "X" ||
                          this.model.GoodsIn,
                        tabIndex:
                          this.model.CompanyCurrency ===
                            this.model.CurrencyCode ||
                          this.model.Status === "C" ||
                          this.model.Status === "X" ||
                          this.model.GoodsIn
                            ? -1
                            : undefined,
                      },
                      validationRules: [
                        {
                          type: "custom",

                          validationCallback: (e) => {
                            e.rule.message = `You have entered an exchange rate of ${formatNumber(
                              e.value,
                              e.formItem.editorOptions.format,
                            )}, which is invalid. Please enter an exchange rate that is greater than 0.0000`;

                            return e.value > 0;
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              items: [
                // {
                //   screenField: "DeliverToBranch",
                //   dataField:
                //     this.baseView.mode == "create"
                //       ? "DeliverTo"
                //       : "DeliveryAddressCompanyName",

                //   onItemClick: this.setDeliverTo,
                //   ref: "DeliveryAddressCompanyName",
                //   displayExpr: "Description",
                //   acceptCustomValue: true,
                //   onCustomItemCreating: (data) => {
                //     if (!data.text) {
                //       return;
                //     } else {
                //       this.deliverToCustomItem(data);
                //     }
                //   },
                // },
                // {
                //   screenField: "DeliveryCompanyView",
                //   editAddress: this.baseView.mode != "review" ? true : false,
                // },
                {
                  screenField: "Branch",
                  label: {
                    text: "Branch",
                  },
                  dataField: "BranchCode",
                  editorOptions: {
                    onItemClick: this.onBranchCodeValueChanged.bind(this),
                    placeholder: this.branchPlaceHolder,
                    elementAttr: {
                      class:
                        this.branchPlaceHolder != "Select"
                          ? "class-multiple"
                          : "class-name",
                    },
                    tabIndex:
                      this.dataGridViewType == "review" ? -1 : undefined,
                    readOnly: this.dataGridViewType == "review",
                  },
                },
                {
                  screenField: "Division",
                  label: {
                    text: "Division",
                  },
                  dataField: "DivisionCode",
                  editorOptions: {
                    onItemClick: this.onDivisionCodeValueChanged.bind(this),
                    placeholder: this.divisionPlaceHolder,
                    elementAttr: {
                      class:
                        this.divisionPlaceHolder != "Select"
                          ? "class-multiple"
                          : "class-name",
                    },
                    tabIndex:
                      this.dataGridViewType == "review" ? -1 : undefined,
                    readOnly: this.dataGridViewType == "review",
                  },
                },

                {
                  itemType: "group",
                  caption: "",
                  cssClass: "deliver-to",
                  items: [
                    {
                      screenField: "DeliverToBranch",
                      dataField:
                        this.baseView.mode == "create"
                          ? "DeliverTo"
                          : "DeliveryAddressCompanyName",
                      ref: "DeliveryAddressCompanyName",
                      // required: true,
                      // editorOptions: {
                      onItemClick: this.setDeliverTo,
                      // allowUpdate: true,
                      // },
                      // dataSourceConfig: {
                      //   // ingnore: true,
                      //   data: deliveryAddressDataSourceItems,
                      // },
                      visible: this.baseView.mode != "review",
                      acceptCustomValue: true,
                      onCustomItemCreating: (data) => {
                        if (!data.text) {
                          return;
                        } else {
                          this.deliverToCustomItem(data);
                        }
                      },
                      editorOptions: {
                        readOnly: this.model.GoodsIn,
                      },
                    },
                    {
                      screenField:
                        this.baseView.mode != "review"
                          ? "DeliverTo"
                          : undefined,
                      dataField: "DeliveryAddressCompanyName",
                      ref: "DeliveryAddressCompanyName",
                      label: {
                        text: "Deliver To",
                      },
                      required: true,
                      visible: this.baseView.mode == "review",
                    },
                    {
                      screenField: "DeliveryCompanyView",
                      editAddress:
                        this.baseView.mode != "review" && !this.model.GoodsIn
                          ? true
                          : false,
                    },
                  ],
                },
              ],
            },
          ],
        },
      ];
    },
    getHeaderScreenJson() {
      return {
        title: {
          createModeIsEditMode: true,
          primary: {
            primary: {
              dataField: this.baseView.mode != "create" ? "Code" : undefined,
              text:
                this.baseView.mode != "create"
                  ? "Purchase Order # "
                  : "Create Purchase Order",
            },
            secondary: {
              dataField: undefined,
              text: undefined,
            },
          },
          secondary: {
            dataField:
              this.baseView.mode != "create" ? "SupplierName" : undefined,
            text: undefined,
          },
        },
      };
    },
    // Footer
    getFooterItems() {
      return [
        {
          screenField: "SalesUMItemCount",
          dataField: "SupplierRequired",
          location: "left",
          label: "Line Count",
          value: 0,
          customCalc: (headerData, gridItems) => {
            var count = 0;
            gridItems.forEach((element) => {
              if (element.ItemCode) count++;
            });

            return count;
          },
        },
        {
          screenField: "SalesUMItemCount",
          dataField: "SupplierRequired",
          location: "left",
          value: 0,
        },
        {
          dataField: "FXLineTotal",
          screenField: "TaxableFXTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-2C",
          label: `Sub Total (${this.model.CurrencyCode})`,
        },
        {
          screenField: "TaxFXTotal",
          dataField: "TaxFXLineTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-2C",
          label: `Tax (${this.model.CurrencyCode})`,
        },
        {
          screenField: "FXTotal",
          dataField: "FXIncTaxLineTotal",
          location: "right",
          value: 0,
          format: "Decimal-16-2C",
          label: `Total (${this.model.CurrencyCode})`,
        },
      ];
    },

    footerLeftItems() {
      var leftItems = this.footerItems.filter((x) => x.location == "left");

      return leftItems
        .map((c) => {
          let globalField = { ...getGlobalField(c.screenField) };
          if (Object.keys(globalField).length == 0) return c;

          if (c.value != undefined) globalField.value = c.value;
          if (c.dataField != undefined) globalField.dataField = c.dataField;
          if (c.label != undefined) globalField.label = c.label;
          if (c.format != undefined) globalField.format = c.format;
          if (c.fieldType != undefined) globalField.fieldType = c.fieldType;
          if (c.length != undefined) globalField.length = c.length;
          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`,
            );
          }
          // if(c.length != undefined) globalField.length = c.length;
          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`,
            );
          }
          if (globalField) return globalField;
          else return c;
        })
        .filter((x) => x != null);
    },
    footerRightItems() {
      // return this.footerItems.filter((x) => x.location == "right");
      var rightItems = this.footerItems.filter(
        (x) =>
          x.location == "right" &&
          (x.hasOwnProperty("visible") ? x.visible : true),
      );

      return rightItems
        .map((c) => {
          let globalField = { ...getGlobalField(c.screenField) };

          if (Object.keys(globalField).length == 0) return c;

          if (c.value != undefined) globalField.value = c.value;
          if (c.dataField != undefined) globalField.dataField = c.dataField;
          if (c.label != undefined) globalField.label = c.label;
          if (c.format != undefined) globalField.format = c.format;

          if (globalField.type === "Decimal") {
            globalField.label = globalField.label.replace(
              "(Customer Currency)",
              `(${this.model.CurrencyCode})`,
            );
          }

          if (globalField) return globalField;
          else return c;
        })
        .filter((x) => x != null);
    },
    backButtonRoute() {
      if (this.baseView.query && this.baseView.query.from) {
        return this.baseView.query.from;
      } else return "/purchase-order";
    },
    // Search Product Items
    searchProductsTabs() {
      if (this.dataGridViewType == "product-entry") {
        return [
          {
            id: 0,
            text: "Associated to the Supplier",
          },
          {
            id: 1,
            text: "Unassociated to the Supplier",
          },
        ];
      } else {
        return [
          {
            id: 0,
            text: "General Ledger List",
          },
        ];
      }
    },
    searchProductsColumns() {
      if (this.dataGridViewType == "product-entry") {
        return [
          {
            caption: "Product",
            dataField: "ProductCode",
            width: 200,
            sortOrder:
              this.getProductSort("SortProductBy").dataField == "ProductCode"
                ? this.getProductSort("SortProductBy").sortOrder
                : undefined,
            sortIndex:
              this.getProductSort("SortProductBy").dataField == "ProductCode"
                ? 0
                : undefined,
          },
          {
            caption: "Description",
            dataField: "PurchaseDescription",
            sortOrder:
              this.getProductSort("SortProductBy").dataField ==
              "PurchaseDescription1"
                ? this.getProductSort("SortProductBy").sortOrder
                : undefined,
            sortIndex:
              this.getProductSort("SortProductBy").dataField ==
              "PurchaseDescription1"
                ? 0
                : undefined,
          },
        ];
      } else {
        return [
          {
            caption: "Account",
            dataField: "ComputedStringCode",
            width: 200,
            sortOrder:
              this.getAccountSort("SortAccountBy").dataField ==
              "ComputedStringCode"
                ? this.getAccountSort("SortAccountBy").sortOrder
                : undefined,
            sortIndex:
              this.getAccountSort("SortAccountBy").dataField == "ProductCode"
                ? 0
                : undefined,
          },
          {
            caption: "Description",
            dataField: "Description",
            sortOrder:
              this.getAccountSort("SortAccountBy").dataField ==
              "ParentGLChartDescription"
                ? this.getAccountSort("SortAccountBy").sortOrder
                : undefined,
            sortIndex:
              this.getAccountSort("SortAccountBy").dataField ==
              "ParentGLChartDescription"
                ? 0
                : undefined,
          },
        ];
      }
    },
    searchProductsDataSource() {
      if (this.dataGridViewType == "product-entry") {
        return ProductService.dataSourceConfig("api/ProductPurchaseList", {
          // select: ["Code", "Description"],
          filter:
            this.searchProductsSelectedIndex == 0
              ? ["SupplierCode", "=", `${this.model.SupplierCode}`]
              : undefined,
          postProcess: (data) => {
            if (this.searchProductsSelectedIndex == 0) return data;
            else {
              var associatedItems = data
                .filter((i) => i.SupplierCode == this.model.SupplierCode)
                .map((i) => i.ProductCode);

              let associatedItemSet = new Set(associatedItems);

              var items = [];

              items = data.filter(
                (element) => !associatedItemSet.has(element.ProductCode),
              );
              return items;
            }
          },
        });
      } else {
        return ProductService.dataSourceConfig("api/GLChart", {
          // select: ["Code", "Description"],
          filter: this.gLChartDataSourceFilter(),
        });
      }
    },

    // DataGrid
    getLocalDataSource() {
      if (this.dataGridViewType == "product-entry") {
        return this.dataSourceProductEntry;
      } else if (this.dataGridViewType == "product-list") {
        return this.dataSourceProductList;
      } else if (this.dataGridViewType == "review") {
        return this.dataSourceReview._array.filter((x) => x.SupplierRequired);
      } else {
        return this.dataSourceGLEntry;
      }
    },
    getColumns() {
      if (this.baseView.mode == "review") return this.reviewListColumns;
      else if (this.dataGridViewType == "product-entry")
        return this.productColumns;
      else if (this.dataGridViewType == "product-list")
        return this.productListColumns;
      else if (this.dataGridViewType == "review") return this.reviewListColumns;
      else return this.glChartColumns;
      // return this.glChartColumns;
    },
    productColumns() {
      var columns = [
        {
          caption: "Product",
          dataField: "ItemCode",
          fixed: true,
          fixedPosition: "left",
          minWidth: 150,
          cssClass: "edit-cell-textbox-field",
          allowSearch: this.baseView.mode == "review",
          allowSorting: this.baseView.mode == "review",
          allowEditing: this.baseView.mode != "review",
          editorOptions: {
            dataSource: PurchaseOrder.dataSourceConfig(
              "api/ProductPurchaseList",
              {
                filter: [["SupplierCode", "=", `${this.model.SupplierCode}`]],
              },
            ),
            displayExpr: "ProductCode",
            valueExpr: "ProductCode",
            searchTimeout: 10,
            searchEnabled: true,
            searchExpr: [
              "ProductCode",
              "PurchaseDescription",
              "ProductDescription",
            ],
            onFocusIn: (e) => {
              this.productCodeFocusIn(e);
            },
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete" id="${data.ProductCode}" >
                            <span class="auto-complete-primary">
                              ${data.ProductCode}
                            </span>
                            <span class="record-secondary gc-grid-code">
                              ${data.PurchaseDescription}
                            </span>
                          </div>`;
            },
            dropDownOptions: {
              minWidth: 400,
            },
            onKeyDown: this.onTabBack,
            onItemClick: (e, lineData) => {
              this.onEnterItemCode({ event: { key: "Enter" } }, lineData);
            },
            onSelectionChanged: (e) => {
              this.onProductCodeSelected(e);
            },
          },
          setCellValue: (newData, value, currentRowData) => {
            newData.ItemCode = value;

            if (!currentRowData.ItemCode && currentRowData.IsNewLine != true)
              this.addNewRow();

            this.productCodeValueChanged(
              { value: value },
              { data: currentRowData },
            );
          },
        },
        // {
        //   dataField: "LineNo",
        //   sortIndex: 0,
        //   sortOrder: 'asc'
        // }
      ];

      return columns.concat(this.getCommonColumns);
    },
    productListColumns() {
      var columns = [
        {
          caption: "Product",
          sortOrder: this.getProductSort("SortProductBy").sortOrder,
          dataField: this.getProductSort("SortProductBy").dataField,
          sortIndex: 0,
          fixed: true,
          fixedPosition: "left",
          minWidth: 220,
          allowEditing: false,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${info.data.ItemDescription}
                        </span> <br />
                      <span class="record-secondary gc-grid-code">
                        ${info.data.ProductCode}
                      </span>
                    </div>`);
          },
        },
        {
          caption: "Description",
          dataField: "PurchaseDescription",
          allowEditing: false,
          visible: false,
        },
      ];
      columns = columns.concat(this.getCommonColumns.slice(1));
      return columns;
    },
    reviewListColumns() {
      var columns = [
        {
          dataField: "ItemType",
          caption: "Type",
          minWidth: ColumnWidth.ItemType.width,
          width: ColumnWidth.ItemType.minWidth,
          allowEditing: false,
        },
        {
          caption: "Product/Account",
          // sortOrder: "asc",
          dataField: "ProductCode",
          // sortIndex: 0,
          minWidth: 200,
          allowEditing: false,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${info.data.ItemDescription}
                        </span> <br />
                      <span class="record-secondary gc-grid-code">
                        ${info.data.ProductCode}
                      </span>
                    </div>`);
          },
        },
        // {
        //   dataField: "LineNo",
        //   sortIndex: 0,
        //   sortOrder: 'asc'
        // }
      ];
      columns = columns.concat(this.getCommonColumns.slice(1));
      return columns;
    },
    glChartColumns() {
      var columns = [
        {
          caption:
            this.baseView.mode == "review" ? "Product/Account" : "Account",
          dataField: "ItemCode",
          fixed: true,
          fixedPosition: "left",
          // width: "auto",
          minWidth: ColumnWidth.AccountCode.minWidth,
          width: ColumnWidth.AccountCode.width,
          // editCellTemplate: "account-code-edit-template",
          cssClass: "edit-cell-textbox-field",
          // sortOrder:
          //   this.baseView.mode == "review"
          //     ? this.getAccountSort("SortAccountBy").sortOrder
          //     : undefined,
          // sortIndex: this.baseView.mode == "review" ? 0 : undefined,

          allowSearch: this.baseView.mode == "review",
          allowSorting: this.baseView.mode == "review",
          allowEditing: this.baseView.mode != "review",
          editorOptions: {
            dataSource: PurchaseOrder.dataSourceConfig("api/GLChart", {
              filter: this.gLChartDataSourceFilter(),
              sort: [{ selector: "ComputedStringCode", asc: true }],
            }),
            displayExpr: "ComputedStringCode",
            valueExpr: "ComputedStringCode",
            searchTimeout: 10,
            searchEnabled: true,
            searchExpr: ["ComputedStringCode", "Description"],
            onFocusIn: (e) => {
              this.productCodeFocusIn(e);
            },
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${data.ComputedStringCode}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${data.Description}
                        </span>
                      </div>`;
            },
            dropDownOptions: {
              width: 400,
            },
            onKeyDown: this.onTabBack,
            onItemClick: (e, lineData) => {
              this.onEnterItemCode({ event: { key: "Enter" } }, lineData);
            },
            onSelectionChanged: (e) => {
              this.onProductCodeSelected(e);
            },
          },
          setCellValue: (newData, value, currentRowData) => {
            newData.ItemCode = value;

            if (!currentRowData.ItemCode && currentRowData.IsNewLine != true)
              this.addNewRow();

            this.productCodeValueChanged(
              { value: value },
              { data: currentRowData },
            );
          },
        },
        // {
        //   dataField: "LineNo",
        //   sortIndex: 0,
        //   sortOrder: 'asc'
        // }
      ];

      var cols = [...this.getCommonColumns];
      cols.splice(6, 0, {
        caption: "Tax",
        dataField: "TaxCode",
        width: 80,
        minWidth: 80,
        allowSearch: this.baseView.mode == "review",
        allowSorting: this.baseView.mode == "review",
        allowEditing:
          this.baseView.mode != "review" && this.model.CurrencyCode == "AUD",
        cssClass: "edit-cell-textbox-field",
        lookup:
          this.baseView.mode != "review"
            ? {
                allowClearing: false,
                dataSource: this.taxCodeDataSourceItems,
                displayExpr: "Code",
                valueExpr: "Code",
              }
            : undefined,
        editorOptions: {
          itemTemplate: (data) => {
            return ` <div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${data.Description}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${data.Code}
                        </span>
                      </div>`;
          },
          dropDownOptions: {
            width: 200,
          },
        },
        setCellValue: (newData, value, currentRowData) => {
          newData.TaxCode = value;

          var tax = this.taxCodeDataSourceItems.filter(
            (t) => t.Code == newData.TaxCode,
          );
          if (tax.length > 0) newData.TaxPcnt = tax[0].Rate;

          newData.FXLineTotal = parseFloat(
            parseFloat(currentRowData.SupplierRequired).roundNumber(4) *
              parseFloat(currentRowData.SupplierFXPrice).roundNumber(4),
          ).roundNumber(2);

          newData.TaxFXLineTotal = parseFloat(
            parseFloat(newData.FXLineTotal).roundNumber(2) *
              parseFloat(newData.TaxPcnt).roundNumber(4) *
              0.01,
          ).roundNumber(2);

          newData.FXIncTaxLineTotal = parseFloat(
            newData.FXLineTotal + newData.TaxFXLineTotal,
          ).roundNumber(2);
        },
      });
      cols.splice(7, 1);
      return columns.concat(cols);
    },
    getCommonColumns() {
      return [
        {
          caption: "Description",
          dataField: "ItemDescription",
          allowEditing: false,
          allowSearch: this.baseView.mode == "review",
          allowSorting: this.baseView.mode == "review",
          minWidth: 250,
        },
        {
          caption: "Item Code",
          dataField: "ItemCode",
          allowEditing: false,
          // allowSearch: this.baseView.mode == "review",
          // allowSorting: this.baseView.mode == "review",
          visible: false,
        },
        {
          caption: "Branch",
          dataField: "BranchCode",
          allowSearch: this.baseView.mode == "review",
          allowSorting: this.baseView.mode == "review",
          allowEditing:
            this.baseView.mode != "review" && this.dataGridViewType != "review",
          lookup:
            this.baseView.mode != "review"
              ? {
                  allowClearing: false,
                  dataSource: this.branchDataSourceItems,
                  displayExpr: "Code",
                  valueExpr: "Code",
                }
              : undefined,
          editorOptions: {
            searchExpr: ["Code", "Description"],
            searchTimeout: 1,
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${data.Code}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${data.Description}
                        </span>
                      </div>`;
            },
            dropDownOptions: {
              width: 250,
            },
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onKeyDown: this.onTabBackFromProdList,
            onItemClick: (e, lineData) => {
              this.onEnterBranchCode({ event: { key: "Enter" } }, lineData);
            },
          },
          width: 85,
          minWidth: 85,
          cssClass: "edit-cell-textbox-field",
          visible: this.getColumnVisible("DisplayBranchInDetail"),
          setCellValue: async (newData, value) => {
            newData.BranchCode = value;

            this.checkMultipleBranchDivision();
          },
        },
        {
          caption: "Division",
          dataField: "DivisionCode",
          allowSearch: this.baseView.mode == "review",
          allowSorting: this.baseView.mode == "review",
          allowEditing:
            this.baseView.mode != "review" && this.dataGridViewType != "review",
          lookup:
            this.baseView.mode != "review"
              ? {
                  allowClearing: false,
                  dataSource: this.divisionDataSourceItems,
                  displayExpr: "Code",
                  valueExpr: "Code",
                }
              : undefined,
          editorOptions: {
            searchExpr: ["Code", "Description"],
            searchTimeout: 1,
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${data.Code}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${data.Description}
                        </span>
                      </div>`;
            },
            dropDownOptions: {
              width: 250,
            },
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onKeyDown: this.onTabBackFromProdList,
            onItemClick: (e, lineData) => {
              this.onEnterDivisionCode({ event: { key: "Enter" } }, lineData);
            },
          },
          width: 85,
          minWidth: 85,
          cssClass: "edit-cell-textbox-field",
          visible: this.getColumnVisible("DisplayDivisionInDetail"),
          setCellValue: async (newData, value) => {
            newData.DivisionCode = value;
            this.checkMultipleBranchDivision();
          },
        },
        {
          caption: "Required By",
          dataField: "RequiredByDate",
          allowSearch: this.baseView.mode == "review",
          allowSorting: this.baseView.mode == "review",
          allowEditing:
            this.baseView.mode != "review" && this.dataGridViewType != "review",
          allowFiltering: false,
          dataType: "date",
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
          format: "dd MMM yyyy",
          editorOptions: {
            displayFormat: "ddMMyyyy",
            useMaskBehavior: true,
            min: this.model.DateIn,
            // onKeyDown: (e, lineData) => {
            //   if (e.event.key == "Enter")
            //     setTimeout(() => {
            //       this.focusOnEditableCell(
            //         lineData.rowIndex,
            //         "SupplierRequired"
            //       );
            //     }, 100);
            // },
            onKeyDown: this.onTabBackFromProdList,
            onFocusIn: (e) => {
              e.event.target.select();
            },
          },
          cssClass: "edit-cell-textbox-field",
          setCellValue: async (newData, value, currentRowData) => {
            if (value && this.model.DateIn) {
              const poDate = new Date(this.model.DateIn);
              poDate.setHours(0, 0, 0, 0);
              const selectedDate = new Date(value);
              selectedDate.setHours(0, 0, 0, 0);
              if (selectedDate < poDate) {
                await this.$alert(
                  "Required By date cannot be earlier than the PO Date.",
                  "Validation Error",
                );
                newData.RequiredByDate = currentRowData.RequiredByDate;
                newData.ETADate = currentRowData.ETADate;
                return;
              }
            }
            newData.RequiredByDate = value;
            newData.ETADate = value;
          },
        },
        {
          caption: "ETA",
          dataField: "ETADate",
          allowSearch: this.baseView.mode == "review",
          allowSorting: this.baseView.mode == "review",
          allowFiltering: false,
          dataType: "date",
          width: ColumnWidth.Date.width,
          minWidth: ColumnWidth.Date.minWidth,
          format: "dd MMM yyyy",
          editorOptions: {
            displayFormat: "ddMMyyyy",
            useMaskBehavior: true,
            min: this.model.DateIn,
            onKeyDown: (e, lineData) => {
              setTimeout(() => {
                this.keyDownOnETADate(e, lineData);
              }, 50);
            },
          },
          cssClass: "edit-cell-textbox-field",
          visible: this.baseView.mode != "create",
          setCellValue: async (newData, value, currentRowData) => {
            if (value && this.model.DateIn) {
              const poDate = new Date(this.model.DateIn);
              poDate.setHours(0, 0, 0, 0);
              const selectedDate = new Date(value);
              selectedDate.setHours(0, 0, 0, 0);
              if (selectedDate < poDate) {
                await this.$alert(
                  "ETA date cannot be earlier than the PO Date.",
                  "Validation Error",
                );
                newData.ETADate = currentRowData.ETADate;
                return;
              }
            }
            newData.ETADate = value;
          },
          allowEditing:
            this.baseView.mode != "review" && this.dataGridViewType != "review",
        },
        {
          caption: "UM",
          dataField: "SupplierUM",
          allowSearch: this.baseView.mode == "review",
          allowSorting: this.baseView.mode == "review",
          allowEditing: false,
          allowFiltering: false,
          width: ColumnWidth.UnitOfMeasure.width,
          minWidth: ColumnWidth.UnitOfMeasure.minWidth,
        },
        {
          caption: "Tax",
          dataField: "TaxCode",
          width: ColumnWidth.TaxCode.width,
          minWidth: ColumnWidth.TaxCode.minWidth,
          allowEditing: false,
        },
        {
          caption: "Quantity",
          dataField: "SupplierRequired",
          dataType: "number",
          format: "##,###,###,###,##0.00",
          allowSearch: this.baseView.mode == "review",
          allowSorting: this.baseView.mode == "review",
          cssClass: "edit-cell-numberbox-field",
          allowEditing:
            this.baseView.mode != "review" && this.dataGridViewType != "review",
          // showEditorAlways: true,

          cellTemplate: "DecimalCell",
          editorOptions: {
            format: "##,###,###,###,##0.00",
            max: 999999999.0,
            maxLength: 9,
            step: 0,
            onFocusIn: (e) => {
              var input = e.element.querySelector("input");
              if (input.value < 0) {
                input.classList.add("gc-state-negative");
                e.element.classList.add("gc-state-negative");
              }
              e.event.target.select();
            },
            onInput: (e) => {
              var inputElement = e.event.target;
              if (inputElement.value.length > 14)
                inputElement.value = inputElement.value.slice(0, 14);
            },
            onKeyDown: (e, lineData) => {
              setTimeout(() => {
                this.keyDownOnQuantity(e, lineData);
              }, 50);
            },
          },
          setCellValue: async (newData, value, currentRowData) => {
            newData.SupplierRequired = value;

            if (
              this.baseView.mode != "create" &&
              currentRowData.SupplierRequired > 0 &&
              currentRowData.SupplierReceivedQty > 0 &&
              currentRowData.SupplierReceivedQty > value
            ) {
              let alert = await this.$alert(
                `${
                  currentRowData.ItemDescription
                } has a required quantity of ${this.formatNumber(
                  value,
                )} which is less than the received quantity of ${this.formatNumber(
                  currentRowData.SupplierReceivedQty,
                )}. Please ensure that the required quantity is greater than or equal to the received quantity.`,
                "Validation Error",
              );

              if (alert) {
                newData.SupplierRequired = currentRowData.SupplierRequired;
                this.reFocusOnQty(currentRowData);
              }
            } else if (
              this.baseView.mode != "create" &&
              currentRowData.SupplierRequired < 0 &&
              currentRowData.SupplierReceivedQty < 0 &&
              currentRowData.SupplierReceivedQty < value
            ) {
              let alert = await this.$alert(
                `${
                  currentRowData.ItemDescription
                } has a required quantity of ${this.formatNumber(
                  value,
                )} which is greater than the received quantity of ${this.formatNumber(
                  currentRowData.SupplierReceivedQty,
                )}. Please ensure that the required quantity is less than or equal to the received quantity.`,
                "Validation Error",
              );

              if (alert) {
                newData.SupplierRequired = currentRowData.SupplierRequired;
                this.reFocusOnQty(currentRowData);
              }
            } else {
              const getindex = this.brokenGridValidations.findIndex(
                (x) =>
                  x.Code === currentRowData.ItemCode &&
                  x.ID == currentRowData.ID,
              );
              if (getindex > -1) {
                // this.brokenGridValidations.splice(getindex, 1);
                this.removeFromGridValidations(getindex);
              }
            }

            newData.TaxPcnt = currentRowData.TaxPcnt;
            newData.SupplierConversion = currentRowData.SupplierConversion;

            if (currentRowData.SupplierFXPrice)
              newData.SupplierFXPrice = currentRowData.SupplierFXPrice;
            else if (
              (!currentRowData.LineNo || currentRowData.isNewRecord) &&
              currentRowData.SupplierPrice
            )
              newData.SupplierFXPrice = currentRowData.SupplierPrice;
            else newData.SupplierFXPrice = 0;

            newData.FXLineTotal = parseFloat(
              parseFloat(newData.SupplierRequired).roundNumber(4) *
                parseFloat(newData.SupplierFXPrice).roundNumber(4),
            ).roundNumber(2);

            newData.TaxFXLineTotal = parseFloat(
              parseFloat(newData.FXLineTotal).roundNumber(2) *
                parseFloat(newData.TaxPcnt).roundNumber(4) *
                0.01,
            ).roundNumber(2);

            newData.FXIncTaxLineTotal = (
              newData.FXLineTotal + newData.TaxFXLineTotal
            ).roundNumber(2);

            newData.RequiredQty =
              newData.SupplierRequired * newData.SupplierConversion;
          },
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
        },
        {
          caption: "Received",
          dataField: "SupplierReceivedQty",
          allowSearch: this.baseView.mode == "review",
          allowSorting: this.baseView.mode == "review",
          allowFiltering: false,
          format: "##,###,###,###,##0.00",
          allowEditing: false,
          visible: this.baseView.mode != "create",
          cellTemplate: "Decimal",
          width: ColumnWidth.Quantity4DecimalPoints.width,
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
        },
        {
          caption: `Unit Price (${this.model.CurrencyCode})`,
          dataField: "SupplierFXPrice",
          dataType: "number",
          format: "$ ##,###,###,###,##0.0000",
          allowSearch: this.baseView.mode == "review",
          allowSorting: this.baseView.mode == "review",
          allowFiltering: false,
          cssClass: "edit-cell-numberbox-field",
          allowEditing:
            this.baseView.mode != "review" && this.dataGridViewType != "review",
          minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
          width: ColumnWidth.Price4DecimalPoints.width,
          editorOptions: {
            format: "$ ##,###,###,###,##0.0000",
            max: 999999999.0,
            min: 0,
            step: 0,
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onInput: (e) => {
              var inputElement = e.event.target;
              if (inputElement.value.length > 18)
                inputElement.value = inputElement.value.slice(0, 18);
            },
            // onKeyDown: this.moveOnEnterKey,
          },
          setCellValue: async (newData, value, currentRowData) => {
            newData.SupplierFXPrice = value;
            newData.SupplierPriceEdited = true;
            newData.TaxPcnt = currentRowData.TaxPcnt;
            newData.SupplierConversion = currentRowData.SupplierConversion;

            newData.FXLineTotal = parseFloat(
              parseFloat(currentRowData.SupplierRequired).roundNumber(4) *
                parseFloat(newData.SupplierFXPrice).roundNumber(4),
            ).roundNumber(2);

            newData.TaxFXLineTotal = parseFloat(
              parseFloat(newData.FXLineTotal).roundNumber(2) *
                parseFloat(newData.TaxPcnt).roundNumber(4) *
                0.01,
            ).roundNumber(2);

            newData.FXIncTaxLineTotal = parseFloat(
              newData.FXLineTotal + newData.TaxFXLineTotal,
            ).roundNumber(2);

            newData.RequiredQty =
              currentRowData.SupplierRequired * newData.SupplierConversion;
          },
        },
        {
          caption: `Ex Total (${this.model.CurrencyCode})`,
          dataField: "FXLineTotal",
          allowSearch: this.baseView.mode == "review",
          allowSorting: this.baseView.mode == "review",
          allowFiltering: false,
          allowEditing: false,
          minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
          width: ColumnWidth.Price4DecimalPoints.width,
          format: "$ ##,###,###,###,##0.00;($ ##,###,###,###,##0.00)",
          cellTemplate: "Decimal",
        },
        {
          caption: `Tax (${this.model.CurrencyCode})`,
          dataField: "TaxFXLineTotal",
          allowSearch: this.baseView.mode == "review",
          allowSorting: this.baseView.mode == "review",
          allowFiltering: false,
          allowEditing: false,
          minWidth: ColumnWidth.TaxFXLineTotal.minWidth,
          width: ColumnWidth.TaxFXLineTotal.width,
          format: "$ ##,###,###,###,##0.00;($ ##,###,###,###,##0.00)",
          cellTemplate: "Decimal",
        },
        {
          caption: `Inc Total (${this.model.CurrencyCode})`,
          dataField: "FXIncTaxLineTotal",
          format: "$ ##,###,###,###,##0.00;($ ##,###,###,###,##0.00)",
          allowSearch: this.baseView.mode == "review",
          allowSorting: this.baseView.mode == "review",
          allowFiltering: false,
          allowEditing: false,
          minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
          width: ColumnWidth.Price4DecimalPoints.width,
          cellTemplate: "Decimal",
        },
        {
          caption: "Comments",
          dataField: "Comment",
          // allowEditing: this.baseView.mode != "review",
          // showEditorAlways: true,
          allowSearch: this.baseView.mode == "review",
          allowSorting: this.baseView.mode == "review",
          allowEditing:
            this.baseView.mode != "review" && this.dataGridViewType != "review",
          cssClass: "edit-cell-textbox-field comment-text",
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onKeyDown: (e, lineData) => {
              setTimeout(() => {
                this.keyDownOnComment(e, lineData);
              }, 50);
            },
            maxLength: 1000,
            maxHeight: 103,
            height: 30,
            valueChangeEvent: "input",
            onInput: (e) => {
              this.commentFieldHeightUpdate(e);
            },
            onInitialized: (e) => {
              this.commentFieldHeightUpdate(e);
            },
          },
          minWidth: ColumnWidth.Comment.minWidth,
          width: ColumnWidth.Comment.width,
          customizeText: (e) => {
            if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
            else return "";
          },
          encodeHtml: false,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
          },
        },
        {
          caption: "Check",
          dataField: "UpdateSupplierPrice",
          editCellTemplate: "sup-price-template",
          headerCellTemplate: "sup-price-header-template",
          allowEditing: true,
          showEditorAlways: true,
          allowSearch: false,
          allowFiltering: false,
          allowSorting: false,
          setCellValue: async (newData, value) => {
            newData.UpdateSupplierPrice = value;
            return newData;
          },
          visible:
            this.baseView.mode != "review" &&
            this.dataGridViewType != "gl-entry",
        },
        {
          caption: "",
          dataField: "",
          type: "buttons",
          buttons: [
            // {
            //   name: "add",
            //   icon: "add",
            //   onClick: (e) => {
            //     this.addNewRowByPosition(e, "add-line");
            //   },
            // },
            {
              name: "copy",
              icon: "copy",
              onClick: (e) => {
                this.addNewRowByPosition(e, "copy-line");
              },
            },
            {
              name: "delete",
              visible: (e) => {
                if (this.baseView.mode != "create") {
                  if (
                    e.row.data.LineStatus == "C" ||
                    e.row.data.SupplierReceivedQty > 0
                  ) {
                    return false;
                  } else return this.dataGridViewType != "product-list";
                } else return this.dataGridViewType != "product-list";
              },
            },
          ],
          visible:
            this.baseView.mode != "review" && this.dataGridViewType != "review",
        },
      ];
    },
    getGridHeight() {
      if (this.headerFormHeight)
        return (
          this.gridHeight - (this.gridExpand ? 6 : this.headerFormHeight) - 117
        );
      else return this.gridHeight - 117;
    },
    getDataGridInstance() {
      return this.$refs["dx-data-grid-comp"].instance;
    },

    // deliveryAddress
    getDeliverToFormItems() {
      return [
        {
          dataField: "DeliveryAddressCompanyName",
          editorType: "dxTextBox",
          label: {
            text: "Name",
          },
          editorOptions: {
            maxLength: "100",
            readOnly:
              this.model.Status === "C" ||
              this.model.Status === "X" ||
              (this.model.Status === "A" && this.model.GoodsIn),
          },
          // allowUpdate: false,
        },
        {
          screenField: "PhysicalAddressStreetLine1",
          dataField: "DeliveryAddressStreetLine1",
          editorOptions: {
            maxLength: "50",
            readOnly:
              this.model.Status === "C" ||
              this.model.Status === "X" ||
              (this.model.Status === "A" && this.model.GoodsIn),
          },
          // allowUpdate: false,
        },
        {
          screenField: "PhysicalAddressStreetLine2",
          dataField: "DeliveryAddressStreetLine2",
          editorOptions: {
            maxLength: "50",
            readOnly:
              this.model.Status === "C" ||
              this.model.Status === "X" ||
              (this.model.Status === "A" && this.model.GoodsIn),
          },
          // allowUpdate: false,
        },
        {
          screenField: "PhysicalAddressSuburb",
          dataField: "DeliveryAddressSuburb",
          editorOptions: {
            maxLength: "50",
            readOnly:
              this.model.Status === "C" ||
              this.model.Status === "X" ||
              (this.model.Status === "A" && this.model.GoodsIn),
          },
          // allowUpdate: false,
        },
        {
          screenField: "PhysicalAddressState",
          dataField: "DeliveryAddressState",
          editorOptions: {
            maxLength: "50",
            readOnly:
              this.model.Status === "C" ||
              this.model.Status === "X" ||
              (this.model.Status === "A" && this.model.GoodsIn),
          },
          // allowUpdate: false,
        },
        {
          screenField: "PhysicalAddressPostcode",
          dataField: "DeliveryAddressPostcode",
          editorOptions: {
            maxLength: "50",
            readOnly:
              this.model.Status === "C" ||
              this.model.Status === "X" ||
              (this.model.Status === "A" && this.model.GoodsIn),
          },
          // allowUpdate: false,
        },
        {
          screenField: "PhysicalAddressCountry",
          dataField: "DeliveryAddressCountry",
          editorOptions: {
            maxLength: "50",
            readOnly:
              this.model.Status === "C" ||
              this.model.Status === "X" ||
              (this.model.Status === "A" && this.model.GoodsIn),
          },
          // allowUpdate: false,
        },
      ];
    },
    deliveryAddressPopupConfig() {
      return {
        save: {
          text: "Save",
          disabled: !this.deliveryAddressFormIsDirty,
          clickCallback: async () => {
            await this.updateDeliveryAddress();
          },
        },
        back: {
          text: "Cancel",
          clickCallback: async () => {
            this.closeDeliveryAddressPopup();
          },
        },
      };
    },
    deliveryAddressFormIsDirty() {
      if (!this.model) return false;

      return (
        this.model.DeliveryAddressCompanyName !==
          this.addressData.DeliveryAddressCompanyName ||
        this.model.DeliveryAddressStreetLine1 !==
          this.addressData.DeliveryAddressStreetLine1 ||
        this.model.DeliveryAddressStreetLine2 !==
          this.addressData.DeliveryAddressStreetLine2 ||
        this.model.DeliveryAddressSuburb !==
          this.addressData.DeliveryAddressSuburb ||
        this.model.DeliveryAddressState !==
          this.addressData.DeliveryAddressState ||
        this.model.DeliveryAddressPostcode !==
          this.addressData.DeliveryAddressPostcode ||
        this.model.DeliveryAddressCountry !==
          this.addressData.DeliveryAddressCountry
      );
    },
  },
  beforeCreate() {
    this.$store.dispatch("defaultUserSettings/setDefaultCompanyBranchDivision");
  },
  methods: {
    commentFieldHeightUpdate(e) {
      let instance = e.component;
      let count = countLineBreaks(instance.instance().option().value);
      if (count < 7) {
        if (count > 2) {
          instance.instance().beginUpdate();
          instance.instance().option("height", count * 16);
          instance.instance().endUpdate();
          this.getDataGridInstance.updateDimensions();
        }
      } else {
        instance.instance().beginUpdate();
        instance.instance().option("height", 250);
        instance.instance().endUpdate();
        this.getDataGridInstance.updateDimensions();
      }
    },
    reFocusOnQty(currentRowData) {
      let dataGrid = this.$refs["dx-data-grid-comp"].instance;
      let rowIndex = dataGrid.getRowIndexByKey(currentRowData.ID);
      if (rowIndex != -1) {
        setTimeout(() => {
          this.focusOnEditableCell(rowIndex, "SupplierRequired");
        }, 10);
      }
    },
    onCellPrepared(e) {
      if (
        (e.rowType === "data" || e.rowType === "header") &&
        e.column.dataField === "UpdateSupplierPrice"
      ) {
        var self = this;

        on(e.cellElement, "mouseover", (arg) => {
          self.$refs[this.tooltipRefName].instance.show(arg.target);
        });

        on(e.cellElement, "mouseout", () => {
          self.$refs[this.tooltipRefName].instance.hide();
        });
      }
    },
    // Copy PO
    copyOrder() {
      // var query = undefined;
      // if (this.baseView.query && this.baseView.query.from)
      //   query = { from: this.baseView.query.from };
      this.$router
        .push({
          path: `/purchase-order-v2/create/${this.baseView.id}`,
          query: {
            copy: true,
          },
        })
        .then(() => {
          this.refreshView();
          this.beforeInit();
        });
    },

    keyDownOnETADate(e, lineData) {
      if (e.event.keyCode == 9 && !e.event.shiftKey) {
        if (lineData.data.SupplierReceivedQty > 0) {
          e.event.preventDefault();
          this.focusOnEditableCell(lineData.rowIndex, "SupplierRequired");
        }
      }
    },
    keyDownOnQuantity(e, lineData) {
      if (e.event.keyCode == 9 && !e.event.shiftKey) {
        if (lineData.data.SupplierReceivedQty > 0) {
          e.event.preventDefault();
          this.focusOnEditableCell(lineData.rowIndex, "Comment");
        }
      }

      if (e.event.keyCode == 9 && e.event.shiftKey) {
        if (lineData.data.SupplierReceivedQty > 0) {
          e.event.preventDefault();
          this.focusOnEditableCell(lineData.rowIndex, "ETADate");
        }
      }
    },
    keyDownOnComment(e, lineData) {
      if (e.event.keyCode == 9 && e.event.shiftKey) {
        if (lineData.data.SupplierReceivedQty > 0) {
          e.event.preventDefault();
          this.focusOnEditableCell(lineData.rowIndex, "SupplierRequired");
        }
      }
    },
    onComment5KeyDown(e) {
      if (e.event.keyCode == 9 && !e.event.shiftKey) {
        e.event.preventDefault();
        if (this.dataGridViewType == "product-list") {
          let nextCol = undefined;
          if (this.getColumnVisible("DisplayBranchInDetail"))
            nextCol = "BranchCode";
          else if (this.getColumnVisible("DisplayDivisionInDetail"))
            nextCol = "DivisionCode";
          else nextCol = "RequiredByDate";
          this.focusOnEditableCell(0, nextCol);
        } else this.focusOnEditableCell(0);
      }
    },
    onSupPriceHeaderUpdate(e) {
      if (e.event) {
        let dsItems = this.getDataGridInstance.getDataSource().items();
        dsItems.forEach((element) => {
          element.UpdateSupplierPrice = e.value;
        });
        this.getDataGridInstance.refresh(true);
      }
    },
    onUpdateSupplierPriceChanged() {
      setTimeout(() => {
        if (!this.getDataGridInstance.getDataSource()) return;

        let dsItems = this.getDataGridInstance.getDataSource().items();
        let updateSupPrice = dsItems.filter((x) => x.UpdateSupplierPrice);

        if (!this.$refs["sup-price-header-template"]) return;

        var refHeadInstance = this.$refs["sup-price-header-template"].instance;
        refHeadInstance.blur();
        var checkBoxHeader = refHeadInstance.element();
        var getInstanceHeader = CheckBox.getInstance(checkBoxHeader);

        if (updateSupPrice.length == 0)
          getInstanceHeader.option("value", false);
        else if (updateSupPrice.length == dsItems.length)
          getInstanceHeader.option("value", true);
        else getInstanceHeader.option("value", undefined);

        // this.getDataGridInstance.refresh(true);
      }, 100);
    },
    onHeaderFormContentReady(e) {
      const headerForm = document.querySelectorAll(".gc-header-form");
      this.headerFormHeight = headerForm[0].clientHeight;

      this.headerDxFormHeight = e.element.offsetHeight;
    },

    closeDeliveryAddressPopup() {
      this.editDeliveryAddressVisible = false;
    },
    showDeliveryAddress() {
      var item = { ...this.model };
      this.addressData = {
        DeliveryAddressCompanyName: item.DeliveryAddressCompanyName,
        DeliveryAddressCountry: item.DeliveryAddressCountry,
        DeliveryAddressPostcode: item.DeliveryAddressPostcode,
        DeliveryAddressState: item.DeliveryAddressState,
        DeliveryAddressStreetLine1: item.DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2: item.DeliveryAddressStreetLine2,
        DeliveryAddressSuburb: item.DeliveryAddressSuburb,
      };
      this.editDeliveryAddressVisible = true;
    },

    updateDeliveryAddress() {
      this.editDeliveryAddressVisible = false;

      this.model.DeliveryAddressCompanyName =
        this.addressData.DeliveryAddressCompanyName;
      this.model.DeliveryAddressStreetLine1 =
        this.addressData.DeliveryAddressStreetLine1;
      this.model.DeliveryAddressStreetLine2 =
        this.addressData.DeliveryAddressStreetLine2;
      this.model.DeliveryAddressSuburb = this.addressData.DeliveryAddressSuburb;
      this.model.DeliveryAddressState = this.addressData.DeliveryAddressState;
      this.model.DeliveryAddressPostcode =
        this.addressData.DeliveryAddressPostcode;
      this.model.DeliveryAddressCountry =
        this.addressData.DeliveryAddressCountry;
    },
    async productCodeFocusIn(e) {
      const headerToolbarForm = await validationEngine.validateGroup(
        "gc-form-header-toolbar",
      );

      if (!headerToolbarForm.isValid) {
        this.setValidationComeBack("Suppiler");
        this.displayValidationSummary(headerToolbarForm.brokenRules);
      } else {
        e.event.target.select();
      }
    },
    backButtonFunction() {
      this.$router
        .push({
          path: this.backButtonRoute,
        })
        .then(() => {
          // this.$store.dispatch("dataContext/setDataViewType", undefined);
        });
    },
    // Search Products PopUp
    popupHidden() {
      this.visibleSearchProducts = false;
      this.searchProductsSelectedIndex = 0;
    },
    // DataGrid Functions

    onProductCodeSelected(e) {
      var index = -1;
      if (this.dataGridViewType == "product-entry") {
        index = this.productDataSourceItems.findIndex(
          (x) => x.ProductCode == e.selectedItem.ProductCode,
        );

        if (index == -1) {
          this.productDataSourceItems.push(e.selectedItem);
        }
      } else {
        index = this.glChartDataSourceItems.findIndex(
          (x) => x.ComputedStringCode == e.selectedItem.ComputedStringCode,
        );

        if (index == -1) {
          this.glChartDataSourceItems.push(e.selectedItem);
        }
      }
      this.selectedProduct = e.selectedItem;
    },
    onSearchProductsRowDblClick(data) {
      this.popupHidden();

      var dataGrid = this.$refs["dx-data-grid-comp"].instance;

      var item = data.data;
      let defaultRequiredByDate = this.model.DateIn
        ? new Date(this.model.DateIn)
        : new Date();
      var index = -1;
      var itemData = undefined;
      if (this.dataGridViewType == "product-entry") {
        index = this.dataSourceProductEntry._array.findIndex(
          (x) => !x.ItemCode,
        );
        if (index != -1) {
          defaultRequiredByDate.setDate(
            defaultRequiredByDate.getDate() + item.SupplierLead,
          );
          itemData = this.dataSourceProductEntry._array[index];
          let dataObj = {
            ...{
              BranchCode: this.model.BranchCode
                ? this.model.BranchCode
                : this.defaultDataModel.DefaultBranchCode,
              DivisionCode: this.model.DivisionCode
                ? this.model.DivisionCode
                : this.defaultDataModel.DefaultDivisionCode,
              RequiredByDate: defaultRequiredByDate,
              Code: item.ProductCode,
              Description: item.ProductDescription,
              ItemDescription: item.PurchaseDescription,
              ItemType: "S",
              ItemCode: item.ProductCode,
              ETADate: this.defaultDataModel.ETADate
                ? this.defaultDataModel.ETADate
                : new Date(),
              SeachItem: true,
            },
            ...item,
          };

          this.dataSourceProductEntry.update(itemData.ID, dataObj);

          if (itemData.IsNewLine != true) this.addNewRow();

          dataGrid.refresh().then(() => {
            var rowIndex = dataGrid.getRowIndexByKey(itemData.ID);

            this.onEnterItemCode(
              { event: { key: "Enter" } },
              { data: dataObj, rowIndex: rowIndex },
            );

            var i = this.productDataSourceItems.findIndex(
              (i) => i.ProductCode == item.ProductCode,
            );
            if (i == -1) {
              this.productDataSourceItems.push(item);
            }
          });
        }
      } else {
        index = this.dataSourceGLEntry._array.findIndex((i) => !i.ItemCode);
        if (index != -1) {
          itemData = this.dataSourceGLEntry._array[index];

          itemData.ProductCode = item.ComputedStringCode;
          itemData.ItemCode = item.ComputedStringCode;
          itemData.ItemDescription = item.Description;

          itemData.BranchCode = this.defaultDataModel.DefaultBranchCode;
          itemData.BranchDescription =
            this.defaultDataModel.DefaultBranchDescription;
          itemData.DivisionCode = this.defaultDataModel.DefaultDivisionCode;
          itemData.DivisionDescription =
            this.defaultDataModel.DefaultDivisionDescription;
          itemData.RequiredByDate = defaultRequiredByDate;
          itemData.ETADate = this.defaultDataModel.ETADate
            ? this.defaultDataModel.ETADate
            : new Date();
          itemData.SupplierUM = "Ea";

          itemData.TaxCode = this.model.CurrencyCode == "AUD" ? "G" : "E";

          let dataObj = {
            ...{
              BranchCode: this.model.BranchCode
                ? this.model.BranchCode
                : itemData.BranchCode,
              DivisionCode: this.model.DivisionCode
                ? this.model.DivisionCode
                : itemData.DivisionCode,
              RequiredByDate: defaultRequiredByDate,
              Code: itemData.ProductCode,
              Description: itemData.ProductDescription1,
              ItemType: "G",
              SeachItem: true,
            },
            ...itemData,
          };
          if (itemData.IsNewLine != true) this.addNewRow();

          this.dataSourceGLEntry.update(itemData.ID, dataObj);

          dataGrid.refresh().then(() => {
            var rowIndex = dataGrid.getRowIndexByKey(itemData.ID);

            this.onEnterItemCode(
              { event: { key: "Enter" } },
              { data: dataObj, rowIndex: rowIndex },
            );
          });
        }
      }
    },
    onEnterItemCode(e, lineData) {
      if (e.event.key == "Enter" && lineData) {
        setTimeout(() => {
          if (lineData && !lineData.data.ItemCode) {
            this.setValidationComeBack("ItemCode", lineData.rowIndex);
            this.displayValidationErrors(["Product Code is required"]);
          } else if (this.getColumnVisible("DisplayBranchInDetail"))
            this.focusOnEditableCell(lineData.rowIndex, "BranchCode");
          else if (this.getColumnVisible("DisplayDivisionInDetail"))
            this.focusOnEditableCell(lineData.rowIndex, "DivisionCode");
          else this.focusOnEditableCell(lineData.rowIndex, "RequiredByDate");
        }, 100);
      }

      if (e.event.keyCode == 9 && e.event.shiftKey) {
        e.event.preventDefault();
        var headerCommentsForm =
          this.$refs["gc-header-comments"].$refs["gc-form-comp"].instance;
        if (headerCommentsForm) {
          headerCommentsForm.getEditor("Comment5").focus();
          // var lastComment = headerCommentsForm
          //   .getEditor("Comment5")
          //   .instance();
          // lastComment.focus();
        }
      }
    },
    onTabBack(e, lineData) {
      if (e.event.keyCode == 9 && e.event.shiftKey && lineData.rowIndex == 0) {
        e.event.preventDefault();
        var headerCommentsForm =
          this.$refs["gc-header-comments"].$refs["gc-form-comp"].instance;
        if (headerCommentsForm) {
          headerCommentsForm.getEditor("Comment5").focus();
          // var lastComment = headerCommentsForm
          //   .getEditor("Comment5")
          //   .instance();
          // lastComment.focus();
        }
      }
    },
    onTabBackFromProdList(e, lineData) {
      if (this.dataGridViewType == "product-list") {
        if (e.event.keyCode == 9 && e.event.shiftKey) {
          if (lineData.column.dataField == "RequiredByDate") {
            if (
              !this.getColumnVisible("DisplayBranchInDetail") &&
              !this.getColumnVisible("DisplayDivisionInDetail")
            ) {
              this.onTabBack(e, lineData);
            }
          }
          if (lineData.column.dataField == "DivisionCode") {
            if (!this.getColumnVisible("DisplayBranchInDetail")) {
              this.onTabBack(e, lineData);
            }
          }
          if (lineData.column.dataField == "BranchCode") {
            this.onTabBack(e, lineData);
          }
        }
      }
    },
    onEnterBranchCode(e, lineData) {
      if (e.event.key == "Enter") {
        setTimeout(() => {
          if (lineData && !lineData.data.ItemCode) {
            this.setValidationComeBack("ItemCode", lineData.rowIndex);
            this.displayValidationErrors(["Product Code is required"]);
          } else if (this.getColumnVisible("DisplayDivisionInDetail"))
            this.focusOnEditableCell(lineData.rowIndex, "DivisionCode");
          else this.focusOnEditableCell(lineData.rowIndex, "RequiredByDate");
        }, 100);
      }
    },
    onEnterDivisionCode(e, lineData) {
      if (e.event.key == "Enter") {
        setTimeout(() => {
          if (lineData && !lineData.data.ItemCode) {
            this.setValidationComeBack("ItemCode", lineData.rowIndex);
            this.displayValidationErrors(["Product Code is required"]);
          } else this.focusOnEditableCell(lineData.rowIndex, "RequiredByDate");
        }, 100);
      }
    },
    moveOnEnterKey(e, lineData) {
      if (e.event.key == "Enter") {
        if (lineData && !lineData.data.ItemCode) {
          this.setValidationComeBack("ItemCode", lineData.rowIndex);
          this.displayValidationErrors(["Product Code is required"]);
        } else if (lineData && lineData.data.SupplierRequired == 0) {
          this.setValidationComeBack("SupplierRequired", lineData.rowIndex);
          this.displayValidationErrors(["Please specify a quantity"]);
        } else {
          var dataGrid = this.$refs["dx-data-grid-comp"].instance;
          var index,
            rowIndex = -1;
          if (this.dataGridViewType == "product-entry") {
            index = this.dataSourceProductEntry._array.findIndex(
              (x) => !x.ItemCode,
            );
            if (index != -1) {
              rowIndex = dataGrid.getRowIndexByKey(
                this.dataSourceProductEntry._array[index].ID,
              );
            }
          } else if (this.dataGridViewType == "product-list") {
            rowIndex = lineData.rowIndex + 1;
          } else {
            index = this.dataSourceGLEntry._array.findIndex((x) => !x.ItemCode);
            if (index != -1) {
              rowIndex = dataGrid.getRowIndexByKey(
                this.dataSourceGLEntry._array[index].ID,
              );
            }
          }

          if (this.dataGridViewType == "product-list") {
            setTimeout(() => {
              this.focusOnEditableCell(rowIndex, "SupplierRequired");
            }, 50);
          } else {
            if (index != -1) {
              setTimeout(() => {
                this.focusOnEditableCell(rowIndex);
              }, 50);
            }
          }
        }
      }
    },
    async addNewRowByPosition(e, type) {
      const headerToolbarForm = await validationEngine.validateGroup(
        "gc-form-header-toolbar",
      );

      if (!headerToolbarForm.isValid) {
        this.setValidationComeBack("Suppiler");
        this.displayValidationSummary(headerToolbarForm.brokenRules);
      } else {
        if (!e.row.data.ItemCode && type == "copy-line") {
          this.setValidationComeBack("ItemCode", e.row.rowIndex);
          this.displayValidationErrors(["Product Code is required"]);
        } else {
          let dataObj = undefined;
          if (this.dataGridViewType == "product-entry") {
            let maxID = Math.max(
              ...this.dataSourceProductEntry._array.map((e) => e.ID),
            );

            if (type == "add-line") {
              dataObj = Object.assign(
                { IsCopyLine: false, IsNewLine: true },
                { ...productEntryBase },
              );
            } else {
              dataObj = Object.assign({ ...e.row.data });
              dataObj.LineNo = 0;
            }
            dataObj.ID = ++maxID;
          } else if (this.dataGridViewType == "product-list") {
            if (type == "copy-line") {
              let filterItem = this.dataSourceProductList._array.filter(
                (x) => x.IsFromList,
              );
              let maxID = 1;
              if (filterItem.length != 0) {
                maxID = Math.max(...filterItem.map((e) => e.ID));
              }

              dataObj = Object.assign({ ...e.row.data });
              dataObj.LineNo = 0;
              dataObj.ID = ++maxID;
            }
          } else {
            // return this.dataSourceGLEntry;
            let maxID = Math.max(
              ...this.dataSourceGLEntry._array.map((e) => e.ID),
            );
            if (type == "add-line") {
              dataObj = Object.assign(
                { IsCopyLine: false, IsNewLine: true },
                { ...productEntryBase },
              );
            } else {
              dataObj = Object.assign({ ...e.row.data });
              dataObj.LineNo = 0;
            }
            dataObj.ID = ++maxID;
          }

          dataObj.UpdateSupplierPrice =
            getFactorByCode(193).Factorc == "Y" ? true : false;
          this.changes = [
            {
              type: "insert",
              data: dataObj,
              insertAfterKey: e.row.key,
            },
          ];

          this.getDataGridInstance.clearSelection();
          this.getDataGridInstance.option("focusedRowIndex", -1);

          setTimeout(() => {
            this.getDataGridInstance.saveEditData();
            this.getDataGridInstance.refresh(true);
          }, 250);
        }
      }
    },
    async completeOrder() {
      let confirmcompletel = await this.$confirm(
        "Do you want to complete this order?",
        "Complete Order",
      );

      if (confirmcompletel) {
        this.showLoading(true);

        let payload = {
          DateIn: this.model.DateIn
            ? this.model.DateIn.toSaveDate()
            : this.model.DateIn,
          DateReceived: new Date().toSaveDate(),
          SupplierCode: this.model.SupplierCode,
          GoodsInDetails: [],
        };

        this.reviewDataSource.forEach((el) => {
          let obj = {
            ActualStockConversion: el.SupplierConversion,
            Comment: el.Comment,
            IsVariable: el.IsVariable,
            ItemCode: el.ItemCode,
            LineComplete: "Y",
            PurchaseOrderCode: el.PurchaseOrderCode,
            PurchaseOrderComment: el.Comment,
            PurchaseOrderLineNo: el.LineNo,
            ReceivedQty: el.SupplierOutstandingQuantity * el.SupplierConversion,
            StandardStockConversion: el.SupplierConversion,
            SupplierReceivedQty: el.SupplierOutstandingQuantity,
            // GoodsInProductBatches: [],
          };
          payload.GoodsInDetails.push(obj);
        });

        await GoodsInService.saveGoodsIn(payload)
          .then((res) => {
            if (res) this.showLoading(false);
            this.$notify(
              `Successfully completed the PO #${this.baseView.id}`,
              "success",
            );

            this.setIgnoreRouteChangeConfirmation();
            this.reload = true;
            this.loaded = false;
            this.beforeInit();
          })
          .catch((error) => {
            this.showLoading(false);
            this.displayServerError(error, "Purchase order failed to complete");
          });
      }
    },
    async cancelOrder() {
      let confirmCancel = await this.$confirm(
        "Do you want to cancel this order?",
        "Cancel Order",
      );

      if (confirmCancel) {
        this.model.NextStatus = "X";
        this.savePurchaseOrder();
      }
    },
    addNewRow() {
      if (this.dataGridViewType == "product-entry") {
        this.addNewLineIntoProductEntry();
      } else if (this.dataGridViewType == "product-list") {
        return;
      } else {
        this.addNewLineIntoGLEntry();
      }
    },
    addNewLineIntoProductEntry(data) {
      let maxID = 10000;

      let dataObj = Object.assign({ ...productEntryBase });
      if (data) {
        dataObj = Object.assign({ IsCopyLine: false, IsNewLine: true }, data);
      }
      dataObj.ID = maxID;

      if (this.dataSourceProductEntry._array.length != 0) {
        maxID = Math.max(
          ...this.dataSourceProductEntry._array.map((e) => e.ID),
        );
        dataObj.ID = ++maxID;
      }

      dataObj.UpdateSupplierPrice =
        getFactorByCode(193).Factorc == "Y" ? true : false;
      this.dataSourceProductEntry.insert(dataObj);
    },
    addNewLineIntoGLEntry(data) {
      let maxID = 20000;

      let dataObj = Object.assign({ ...productEntryBase });
      if (data) {
        dataObj = Object.assign({ IsCopyLine: false, IsNewLine: true }, data);
      }
      dataObj.ID = maxID;

      if (this.dataSourceGLEntry._array.length != 0) {
        maxID = Math.max(...this.dataSourceGLEntry._array.map((e) => e.ID));
        dataObj.ID = ++maxID;
      }

      dataObj.UpdateSupplierPrice = false;
      this.dataSourceGLEntry.insert(dataObj);
    },
    addToValidationSum(message) {
      this.displayValidationSummary([
        {
          message: message,
        },
      ]);
    },
    addInToGridValidations(getindex, msgObj) {
      this.brokenGridValidations[getindex] = msgObj;
    },
    pushInTOGridValidations(msgObj) {
      this.brokenGridValidations.push(msgObj);
    },
    removeFromGridValidations(getindex) {
      this.brokenGridValidations.splice(getindex, 1);
    },
    checkMultipleBranchDivision() {
      if (!this.loaded) return;
      var items = this.$refs["dx-data-grid-comp"].instance
        .getDataSource()
        .items();
      var branchCode,
        divisionCode = undefined;

      var headerForm =
        this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;

      var branchEditor = headerForm.getEditor("BranchCode");
      var branchEl = branchEditor.element();

      var divisionEditor = headerForm.getEditor("DivisionCode");
      var divisionEl = divisionEditor.element();

      var etaEditor = headerForm.getEditor("ETA");
      // var etaEl = etaEditor.element();
      let etaValue = undefined;

      items.forEach((item) => {
        if (item.ItemCode) {
          if (branchCode) {
            if (branchCode != item.BranchCode) {
              branchEditor.option("value", undefined);
              branchEditor.option("placeholder", "Multiple entries specified");
              branchEl.classList.add("class-multiple");
            }
          } else {
            branchCode = item.BranchCode;

            branchEditor.option("value", item.BranchCode);
            branchEditor.option("placeholder", "Select");
            branchEl.classList.add("class-name");
          }

          if (divisionCode) {
            if (divisionCode != item.DivisionCode) {
              divisionEditor.option("value", undefined);
              divisionEditor.option(
                "placeholder",
                "Multiple entries specified",
              );
              divisionEl.classList.add("class-multiple");
            }
          } else {
            divisionCode = item.DivisionCode;

            divisionEditor.option("value", item.DivisionCode);
            divisionEditor.option("placeholder", "Select");
            divisionEl.classList.add("class-name");
          }
          etaValue = item.ETADate;
        }
      });

      if (etaValue && this.loaded && etaEditor) {
        etaEditor.option("value", new Date(etaValue));
      }
    },
    productCodeValueChanged(e, cellInfo) {
      var itemData = undefined;

      let defaultRequiredByDate = this.model.DateIn
        ? new Date(this.model.DateIn)
        : new Date();
      if (e.itemData) itemData = e.itemData;
      var index = -1;
      if (this.dataGridViewType == "product-entry") {
        index = this.productDataSourceItems.findIndex(
          (i) => i.ProductCode == e.value,
        );
        if (index != -1) itemData = this.productDataSourceItems[index];

        if (itemData) {
          defaultRequiredByDate.setDate(
            defaultRequiredByDate.getDate() + itemData.SupplierLead,
          );
          let dataObj = {
            ...{
              BranchCode: this.model.BranchCode,
              DivisionCode: this.model.DivisionCode,
              RequiredByDate: defaultRequiredByDate,
              Code: itemData.ProductCode,
              Description: itemData.ProductDescription,
              ItemDescription: itemData.PurchaseDescription,
              ItemType: "S",
              ItemCode: itemData.ProductCode,
              ETADate: this.defaultDataModel.ETADate
                ? this.defaultDataModel.ETADate
                : new Date(),
            },
            ...itemData,
          };

          this.dataSourceProductEntry.update(cellInfo.data.ID, dataObj);
        }
      } else {
        index = this.glChartDataSourceItems.findIndex(
          (i) => i.ComputedStringCode == e.value,
        );
        if (index != -1) {
          itemData = this.glChartDataSourceItems[index];

          itemData.ProductCode = itemData.ComputedStringCode;
          itemData.ItemCode = itemData.ComputedStringCode;
          itemData.ItemDescription = itemData.Description;

          itemData.BranchCode = this.defaultDataModel.DefaultBranchCode;
          itemData.BranchDescription =
            this.defaultDataModel.DefaultBranchDescription;
          itemData.DivisionCode = this.defaultDataModel.DefaultDivisionCode;
          itemData.DivisionDescription =
            this.defaultDataModel.DefaultDivisionDescription;
          itemData.RequiredByDate = defaultRequiredByDate;
          itemData.ETADate = this.defaultDataModel.ETADate
            ? this.defaultDataModel.ETADate
            : new Date();
          itemData.SupplierUM = "Ea";
          itemData.SupplierRequired = 1;

          itemData.TaxCode = this.model.CurrencyCode == "AUD" ? "G" : "E";

          var tax = this.taxCodeDataSourceItems.filter(
            (t) => t.Code == itemData.TaxCode,
          );
          if (tax.length > 0) itemData.TaxPcnt = tax[0].Rate;

          let dataObj = {
            ...{
              BranchCode: this.model.BranchCode,
              DivisionCode: this.model.DivisionCode,
              RequiredByDate: defaultRequiredByDate,
              Code: itemData.ProductCode,
              Description: itemData.ProductDescription1,
              ItemType: "G",
            },
            ...itemData,
          };

          this.dataSourceGLEntry.update(cellInfo.data.ID, dataObj);
        }
      }
    },
    getColumnVisible(SettingName) {
      var data = this.screenSettings.filter(
        (x) => x.SettingName == SettingName,
      );

      if (data.length > 0) {
        if (data[0].SettingValue == "N") return false;
        else return true;
      } else return true;
    },
    onContentReady(e) {
      if (this.baseView.mode == "edit" && !this.contentReady)
        this.focusCellOnEditMode(e.component);
      this.contentReady = true;

      if (this.baseView.mode != "review")
        setTimeout(() => {
          this.onUpdateSupplierPriceChanged();

          this.checkBranchSpecs();
        }, 250);
    },
    onOptionChanged(e) {
      if (e.fullName == "dataSource" && this.model.SupplierCode) {
        var dataGrid = this.$refs["dx-data-grid-comp"].instance;
        var rowIndex,
          i = -1;

        setTimeout(() => {
          if (this.dataGridViewType == "product-entry") {
            i = this.dataSourceProductEntry._array.findIndex(
              (x) => !x.ItemCode,
            );
            if (i != -1) {
              rowIndex = dataGrid.getRowIndexByKey(
                this.dataSourceProductEntry._array[i].ID,
              );
            }
          } else {
            i = this.dataSourceGLEntry._array.findIndex((x) => !x.ItemCode);
            if (i != -1) {
              rowIndex = dataGrid.getRowIndexByKey(
                this.dataSourceGLEntry._array[i].ID,
              );
            }
          }

          if (rowIndex != -1) this.focusOnEditableCell(rowIndex);
        }, 250);
      }
    },
    focusOnEditableCell(rowIndex, col) {
      var columnName = col ? col : "ItemCode";
      var dataGrid = this.$refs["dx-data-grid-comp"].instance;

      var cellElement = dataGrid.getCellElement(rowIndex, columnName);
      dataGrid.focus(cellElement);
      setTimeout(() => {
        dataGrid.editCell(rowIndex, columnName);
      }, 10);
    },
    onToolbarPreparing(e) {
      e.toolbarOptions.items.push({
        location: "before",
        widget: "dxSelectBox",
        disabled: this.baseView.mode != "review" ? false : true,
        visible: this.baseView.mode != "review",
        options: {
          width: 200,
          items: [
            {
              label: "Product List",
              value: "product-list",
            },
            {
              label: "Product",
              value: "product-entry",
            },
            {
              label: "GL Entry",
              value: "gl-entry",
            },
            {
              label: "Review",
              value: "review",
            },
          ],
          displayExpr: "label",
          valueExpr: "value",
          value: this.dataGridViewType,
          onValueChanged: (e) => {
            this.dataGridViewType = e.value;
          },
        },
      });
      e.toolbarOptions.items.push({
        location: "before",
        widget: "dxButton",
        options: {
          icon: undefined,
          text: "Search",
          elementAttr: {
            class: "cx-color-button",
          },
          onClick: async () => {
            const headerToolbarForm = await validationEngine.validateGroup(
              "gc-form-header-toolbar",
            );

            if (!headerToolbarForm.isValid) {
              this.setValidationComeBack("Suppiler");
              this.displayValidationSummary(headerToolbarForm.brokenRules);
            } else {
              this.visibleSearchProducts = true;
            }
          },
          visible: this.baseView.mode != "review",
          disabled:
            this.dataGridViewType == "product-list" ||
            this.dataGridViewType == "review",
        },
      });

      e.toolbarOptions.items.push({
        location: "after",
        locateinmenu: "auto",
        widget: "dxButton",
        // visible: !this.isTablet,
        options: {
          icon: this.gridExpand ? "collapse" : "expand",
          onClick: this.expandGrid,
          elementAttr: {
            id: "so-v4-grid-expand",
          },
        },
      });
    },
    onSaved(e) {
      if (e.changes && e.changes.length > 0) {
        var change = e.changes[0];

        if (change.insertAfterKey != undefined) {
          var element = change.data;
          var index = -1;
          if (this.dataGridViewType == "product-entry") {
            index = this.dataSourceProductEntry._array.findIndex(
              (x) => x.ID == change.insertAfterKey,
            );

            this.dataSourceProductEntry._array.splice(
              this.dataSourceProductEntry._array.length - 1,
              1,
            );
            this.dataSourceProductEntry._array.splice(index + 1, 0, element);
          } else if (this.dataGridViewType == "gl-entry") {
            index = this.dataSourceGLEntry._array.findIndex(
              (x) => x.ID == change.insertAfterKey,
            );

            this.dataSourceGLEntry._array.splice(
              this.dataSourceGLEntry._array.length - 1,
              1,
            );
            this.dataSourceGLEntry._array.splice(index + 1, 0, element);
          }

          if (index != -1)
            setTimeout(() => {
              this.focusOnEditableCell(index + 1);
            }, 100);
        }
      }
    },
    expandGrid() {
      this.$store.dispatch("ui/setGridExpand", !this.gridExpand);
      setTimeout(() => {
        var dataGrid = this.$refs["dx-data-grid-comp"].instance;

        dataGrid.beginUpdate();
        dataGrid.updateDimensions();
        dataGrid.endUpdate();

        dataGrid.refresh(true);
      }, 500);
    },
    onEditorPreparing(e) {
      if (e.editorOptions && e.editorOptions.onKeyDown) {
        let func = e.editorOptions.onKeyDown;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel")
          e.editorOptions.onKeyDown = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.editorOptions && e.editorOptions.onItemClick) {
        let func = e.editorOptions.onItemClick;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel")
          e.editorOptions.onItemClick = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.dataField && e.dataField == "ItemCode") {
        e.editorName = "dxSelectBox";
      }

      if (e.dataField && e.dataField == "Comment") {
        e.editorName = "dxTextArea";
      }
    },
    onEditingStart(e) {
      if (this.baseView.mode != "create" && e.data.LineStatus == "C") {
        e.cancel = true;
      } else {
        if (
          this.baseView.mode != "create" &&
          (e.column.dataField == "SupplierFXPrice" ||
            e.column.dataField == "TaxCode")
        ) {
          if (e.data.SupplierReceivedQty > 0) e.cancel = true;
        }
      }
    },
    onRowRemoved(e) {
      if (this.dataGridViewType == "product-entry") {
        let product = this.dataSourceProductList._array.find(
          (x) => x.ID == e.data.ID && x.ItemCode == e.data.ItemCode,
        );

        if (product) {
          let index = this.dataSourceProductList._array.findIndex(
            (x) => x.ID == e.data.ID && x.ItemCode == e.data.ItemCode,
          );

          // check if we have multiple items for the same Itemcode before removing it from
          // product list source
          let moreThanOneLineForTheItem =
            this.dataSourceProductList._array.filter(
              (x) => x.ItemCode == e.data.ItemCode,
            ).length > 1;
          if (moreThanOneLineForTheItem) {
            this.dataSourceProductList._array.splice(index, 1);
          } else {
            this.dataSourceProductList.update(product.ID, {
              ...product,
              SupplierRequired: 0,
              SupplierFXPrice: 0,
              FXLineTotal: 0,
              TaxFXLineTotal: 0,
              FXIncTaxLineTotal: 0,
              Comment: "",
            });
          }
        }
      }
    },
    onRowUpdated(e) {
      if (this.dataGridViewType == "product-list") {
        let product = this.dataSourceProductEntry._array.find(
          (x) => x.ID == e.data.ID && x.ItemCode == e.data.ItemCode,
        );

        if (product) {
          if (e.data.SupplierRequired == 0) {
            let index = this.dataSourceProductEntry._array.findIndex(
              (x) => x.ID == e.data.ID && x.ItemCode == e.data.ItemCode,
            );
            this.dataSourceProductEntry._array.splice(index, 1);
          } else {
            this.dataSourceProductEntry.update(e.data.ID, e.data);
          }
        } else {
          this.dataSourceProductEntry._array.splice(
            this.dataSourceProductEntry._array.length - 1,
            0,
            e.data,
          );
        }
      }

      if (this.dataGridViewType == "product-entry") {
        let product = this.dataSourceProductList._array.find(
          (x) =>
            x.ItemCode == e.data.ItemCode &&
            !x.SupplierFXPrice &&
            !x.SupplierRequired,
        );
        if (product) {
          let index = this.dataSourceProductList._array.findIndex(
            (x) => x.ItemCode == product.ItemCode && x.ID == product.ID,
          );
          this.dataSourceProductList._array.splice(index, 1, e.data);
        } else {
          let product = this.dataSourceProductList._array.find(
            (x) => x.ID == e.data.ID && x.ItemCode == e.data.ItemCode,
          );
          if (product) {
            this.dataSourceProductList.update(e.data.ID, e.data);
          } else {
            this.dataSourceProductList.insert(e.data);
          }
        }
      }
    },

    // Footer
    async setFooterItems(gridItems) {
      // this.showFooter = false;
      this.getFooterItems
        .filter((x) => (x.hasOwnProperty("visible") ? x.visible : true))
        .forEach((x) => {
          x.value = this.updateValue(x.dataField, gridItems);
          if (x.customCalc) x.value = x.customCalc(this.model, gridItems);
        });
      this.footerItems = this.getFooterItems;
      this.showFooter = true;
    },
    updateValue(dataField, items) {
      let result = 0;
      if (items.length > 0)
        items.forEach((x) => {
          if (x.CheckInclude || this.baseView.mode == "review")
            result += parseFloat(x[dataField]).roundNumber(2);
          else if (x.CheckInclude == undefined)
            result += parseFloat(x[dataField]).roundNumber(2);
        });

      return result;
    },
    // END

    // Heade Form Functions

    async setBranchDataSourceItems() {
      let branchDS = BranchService.dataSourceConfig("api/Branch", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Code", asc: true }],
        preventPagination: true,
      });

      this.branchDataSourceItems = await branchDS.load();
    },
    async setDivisionDataSourceItems() {
      let divisionDS = DivisionService.dataSourceConfig("api/Division", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Code", asc: true }],
        preventPagination: true,
      });

      this.divisionDataSourceItems = await divisionDS.load();
    },
    async setTaxCodeDataSourceItems() {
      let taxCodeDS = TaxCategoryService.dataSourceConfig("api/Tax", {
        filter: [["Inactive", "=", "N"]],
        sort: [{ selector: "Description", asc: false }],
        preventPagination: true,
      });

      this.taxCodeDataSourceItems = await taxCodeDS.load();
    },
    async onSupplierItemClick(e) {
      let itemData = e.itemData;
      if (!itemData) {
        return;
      }
      if (itemData.DefaultBranchCode) {
        BranchService.getByCode(itemData.DefaultBranchCode).then(({ data }) => {
          this.defaultDataModel.DefaultBranchDescription =
            data.value[0].Description;
          this.model.DeliveryAddressCompanyName =
            this.defaultDataModel.DefaultBranchDescription;
          this.setDeliverTo(this.model, {
            itemData: data.value[0],
          });
        });
        this.defaultDataModel.DefaultBranchCode = this.model.BranchCode =
          itemData.DefaultBranchCode;
        this.model.DeliverTo = itemData.DefaultBranchCode;
      } else if (
        getDefaultUserSettings().BranchCode &&
        getDefaultUserSettings().BranchCode != this.model.BranchCode
      ) {
        this.defaultDataModel.DefaultBranchCode =
          this.model.BranchCode =
          this.model.DeliverTo =
            getDefaultUserSettings().BranchCode;
        BranchService.getByCode(getDefaultUserSettings().BranchCode).then(
          ({ data }) => {
            this.model.DeliveryAddressCompanyName = data.value[0].Description;
            this.setDeliverTo(this.model, {
              itemData: data.value[0],
            });
          },
        );
      } else {
        if (!this.defaultDataModel.DefaultBranchCode)
          await BranchService.getDefault().then((res) => {
            this.defaultDataModel.DefaultBranchCode =
              this.model.BranchCode =
              this.model.DeliverTo =
                res.data.value[0].Code;
            this.defaultDataModel.DefaultBranchDescription =
              this.model.DeliveryAddressCompanyName =
                res.data.value[0].Description;

            this.setDeliverTo(this.model, {
              itemData: res.data.value[0],
            });
          });
      }

      this.model.Supplier = itemData;
      this.model.SupplierCode = itemData.Code;
      this.model.SupplierName = itemData.Name;

      if (this.model.CurrencyCode != itemData.CurrencyCode) {
        this.model.CurrencyCode = itemData.CurrencyCode;
        let result = await CompanyCurrencyService.getByCurrencyCode(
          this.model.CurrencyCode,
        );
        this.model.ExchangeRate = result.data.value[0].SellRate;
      }

      this.dataSourceProductEntry.clear();
      this.dataSourceGLEntry.clear();
      this.changes = [];

      for (let index = 0; index < 1; index++) {
        this.addNewLineIntoProductEntry();

        this.addNewLineIntoGLEntry();
      }

      var dataGrid = this.$refs["dx-data-grid-comp"].instance;
      dataGrid.refresh();

      // this.getPurcharseProductItems();

      // if (this.dataGridViewType != "product-entry") {
      //   this.dataGridViewType = "product-entry";
      // }

      // var i = this.dataSourceProductEntry._array.findIndex((x) => !x.ItemCode);

      // if (i != -1) {
      //   var rowIndex = dataGrid.getRowIndexByKey(
      //     this.dataSourceProductEntry._array[i].ID
      //   );

      //   var cellElement = dataGrid.getCellElement(rowIndex, "ItemCode");
      //   dataGrid.focus(cellElement);
      //   dataGrid.editCell(rowIndex, "ItemCode");
      // }
    },

    async getProductPurchaseList(supplierCode) {
      this.productPurchaseListItems = [];
      this.dataSourceProductList.clear();
      await ProductService.getProductPurchaseList(
        `SupplierCode eq '${supplierCode}'`,
        {
          select: [
            "PurchaseDescription",
            "PurchaseDescription1",
            "ProductCode",
            "ProductDescription",
            "ProductDescription1",
            "RecordId",
            "SupplierConversion",
            "SupplierUM",
            "SupplierPrice",
            "IsBatchProduct",
            "ItemType",
            "SupplierCode",
            "TaxCode",
            "TaxPcnt",
            "SupplierLead",
          ],
        },
      ).then((res) => {
        if (this.baseView.mode != "review") {
          let mergeItems = this.dataSourceReview._array.filter(
            (x) => x.ItemType == "S",
          );
          if (mergeItems.length > 0) {
            mergeItems.forEach((element) => {
              this.dataSourceProductList.insert(element);
            });
          }
        }
        res.data.value.forEach((x, index) => {
          if (this.SupplierData && this.SupplierData.IsTaxableSupplier == "N") {
            x.TaxCode = "E";
            x.TaxPcnt = 0;
          }

          let maxID = index;

          if (this.dataSourceProductList._array.length > 0)
            maxID = Math.max(
              ...this.dataSourceProductList._array.map((e) => e.ID),
            );

          x.ID = ++maxID;

          let defaultRequiredByDate = this.model.DateIn
            ? new Date(this.model.DateIn)
            : new Date();

          x.RequiredByDate = new Date(
            defaultRequiredByDate.setDate(
              defaultRequiredByDate.getDate() + x.SupplierLead,
            ),
          );

          x.BranchCode = this.defaultDataModel.DefaultBranchCode;
          x.BranchDescription = this.defaultDataModel.DefaultBranchDescription;
          x.DivisionCode = this.defaultDataModel.DefaultDivisionCode;
          x.DivisionDescription =
            this.defaultDataModel.DefaultDivisionDescription;

          x.ItemCode = x.ProductCode;
          x.ItemDescription = x.PurchaseDescription;
          x.Code = x.ProductCode;
          x.Description = x.ProductDescription;

          x.ItemType = "S";
          x.LineType = "S";
          x.FXTotal = 0;
          x.SupplierUMQuantity = 0;
          x.FXPrice = 0;
          x.FXAmount = 0;
          x.SupplierReceivedQty = 0;
          x.GoodsInCode = "";
          x.LineNo = 0;
          x.FXTaxLineTotal = 0;
          x.FXIncTaxLineTotal = 0;

          x.SupplierRequired = 0;
          x.SupplierFXPrice = 0;
          x.FXLineTotal = 0;
          x.TaxFXLineTotal = 0;
          // x.RequiredByDate = new Date();
          x.ETADate = new Date();
          x.IsVariable = "N";
          x.UpdateSupplierPrice =
            getFactorByCode(193).Factorc == "Y" ? true : false;
          x.IsFromList = true;

          let product = this.dataSourceProductList._array.find(
            (p) => x.ItemCode == p.ItemCode,
          );
          if (!product) this.dataSourceProductList.insert(x);
        });

        if (this.loaded) {
          this.$nextTick(() => {
            this.getDataGridInstance.refresh(true);
          });
        }
      });
    },
    deliverToCustomItem(data) {
      this.model.DeliveryAddressCompanyName = data.text;

      data.customItem = {
        DeliveryAddressCompanyName: this.model.DeliveryAddressCompanyName,
        DeliveryAddressStreetLine1: this.model.DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2: this.model.DeliveryAddressStreetLine2,
        DeliveryAddressSuburb: this.model.DeliveryAddressSuburb,
        DeliveryAddressState: this.model.DeliveryAddressState,
        DeliveryAddressPostcode: this.model.DeliveryAddressPostcode,
        DeliveryAddressCountry: this.model.DeliveryAddressCountry,
      };
    },

    async onBranchCodeValueChanged(e) {
      let confirmBranchChange = await this.$confirm(
        "Changing the branch will update the branch for all PO lines, are you sure you want to continue?",
        "Confirm Branch Change",
      );
      if (confirmBranchChange) {
        this.branchPlaceHolder = "Select";
        this.model.BranchChanged = true;
        this.defaultDataModel.DefaultBranchCode = this.model.BranchCode;
        this.defaultDataModel.DefaultBranchDescription = e.itemData.Description;
        this.model.DeliverTo = e.itemData.Code;
        this.model.DeliveryAddressCompanyName = e.itemData.Description;

        this.setDeliverTo(this.model, e);

        var dataObj = {
          BranchCode: this.defaultDataModel.DefaultBranchCode,
          BranchDescription: this.defaultDataModel.DefaultBranchDescription,
        };

        // if (this.dataGridViewType == "product-entry") {
        this.dataSourceProductEntry._array.forEach((element) => {
          if (element.ItemCode) {
            this.dataSourceProductEntry.update(element.ID, dataObj);
          }
        });
        // } else if (this.dataGridViewType == "product-list") {
        this.dataSourceProductList._array.forEach((element) => {
          if (element.ItemCode) {
            this.dataSourceProductList.update(element.ID, dataObj);
          }
        });
        // } else {
        this.dataSourceGLEntry._array.forEach((element) => {
          if (element.ItemCode) {
            this.dataSourceGLEntry.update(element.ID, dataObj);
          }
        });
        // }

        var dataGrid = this.$refs["dx-data-grid-comp"].instance;
        dataGrid.refresh();
      } else {
        if (this.branchPlaceHolder != "Select") {
          this.model.BranchCode = undefined;
          e.component.beginUpdate();
          e.component.option("value", undefined);
          e.component.endUpdate();
          return;
        }
        this.model.BranchCode = this.defaultDataModel.DefaultBranchCode;
        if (this.baseView.mode != "create") {
          e.component.beginUpdate();
          if (!this.model.BranchChanged) {
            e.component.option("value", undefined);
          } else {
            e.component.option(
              "value",
              this.defaultDataModel.DefaultBranchCode,
            );
          }
          e.component.endUpdate();
        }
      }
    },

    async onDivisionCodeValueChanged(e) {
      let confirmDivisionChange = await this.$confirm(
        "Changing the Division will update the division for all PO lines, are you sure you want to continue?",
        "Confirm Division Change",
      );
      if (confirmDivisionChange) {
        this.divisionPlaceHolder = "Select";
        this.model.DivisionChanged = true;
        this.defaultDataModel.DefaultDivisionCode = this.model.DivisionCode;
        this.defaultDataModel.DefaultDivisionDescription =
          e.itemData.Description;

        var dataObj = {
          DivisionCode: this.defaultDataModel.DefaultDivisionCode,
          DivisionDescription: this.defaultDataModel.DefaultDivisionDescription,
        };

        // if (this.dataGridViewType == "product-entry") {
        this.dataSourceProductEntry._array.forEach((element) => {
          if (element.ItemCode) {
            this.dataSourceProductEntry.update(element.ID, dataObj);
          }
        });
        // } else if (this.dataGridViewType == "product-list") {
        this.dataSourceProductList._array.forEach((element) => {
          if (element.ItemCode) {
            this.dataSourceProductList.update(element.ID, dataObj);
          }
        });
        // } else {
        this.dataSourceGLEntry._array.forEach((element) => {
          if (element.ItemCode) {
            this.dataSourceGLEntry.update(element.ID, dataObj);
          }
        });
        // }

        var dataGrid = this.$refs["dx-data-grid-comp"].instance;
        dataGrid.refresh();
      } else {
        if (this.divisionPlaceHolder != "Select") {
          this.model.DivisionCode = undefined;
          e.component.beginUpdate();
          e.component.option("value", undefined);
          e.component.endUpdate();
          return;
        }
        this.model.DivisionCode = this.defaultDataModel.DefaultDivisionCode;
        if (this.baseView.mode != "create") {
          e.component.beginUpdate();
          if (!this.model.DivisionChanged) {
            e.component.option("value", undefined);
          } else {
            e.component.option(
              "value",
              this.defaultDataModel.DefaultDivisionCode,
            );
          }
          e.component.endUpdate();
        }
      }
    },

    async onDateInValueChanged(e) {
      if (!e.value || !e.event) return;
      const oldDate = e.previousValue;
      const newDate = e.value;
      const confirmDateChange = await this.$confirm(
        this.baseView.mode === "edit"
          ? "You have changed the PO Date. Would you like to shift all 'Required By' and 'ETA' dates to maintain your schedule?"
          : "You have changed the PO Date. Would you like to shift all 'Required By' dates to maintain your schedule?",
        "PO Date Changed",
      );
      if (confirmDateChange) {
        if (oldDate) {
          const toMidnight = (d) => {
            const n = new Date(d);
            n.setHours(0, 0, 0, 0);
            return n;
          };
          const diffDays = Math.round(
            (toMidnight(newDate).getTime() - toMidnight(oldDate).getTime()) /
              (1000 * 60 * 60 * 24),
          );
          const allSources = [
            this.dataSourceProductEntry,
            this.dataSourceProductList,
            this.dataSourceGLEntry,
          ];
          // Pre-capture original dates before any mutation so shared object
          // references (create mode) and independent copies (edit mode) both
          // shift exactly once from the correct original value.
          // Key: `${sourceIndex}-${element.ID}` to handle same ID across sources.
          const originalDates = new Map();
          allSources.forEach((ds, si) => {
            ds._array.forEach((element) => {
              if (element.ItemCode && element.RequiredByDate) {
                originalDates.set(`${si}-${element.ID}`, {
                  requiredByDate: new Date(element.RequiredByDate),
                  etaDate: element.ETADate ? new Date(element.ETADate) : null,
                });
              }
            });
          });
          allSources.forEach((ds, si) => {
            ds._array.forEach((element) => {
              const key = `${si}-${element.ID}`;
              if (element.ItemCode && originalDates.has(key)) {
                const { requiredByDate, etaDate } = originalDates.get(key);
                const shiftedRequiredBy = new Date(requiredByDate);
                shiftedRequiredBy.setDate(
                  shiftedRequiredBy.getDate() + diffDays,
                );
                const updateObj = { RequiredByDate: shiftedRequiredBy };
                if (etaDate) {
                  const shiftedETA = new Date(etaDate);
                  shiftedETA.setDate(shiftedETA.getDate() + diffDays);
                  updateObj.ETADate = shiftedETA;
                }
                ds.update(element.ID, updateObj);
              }
            });
          });
          var dataGrid = this.$refs["dx-data-grid-comp"].instance;
          dataGrid.refresh();
        }
      } else {
        this.model.DateIn = oldDate || undefined;
        e.component.beginUpdate();
        e.component.option("value", this.model.DateIn);
        e.component.endUpdate();
      }
    },

    async onETAValueChanged(e) {
      if (!e.value || !e.event) return;
      let confirmETAChange = await this.$confirm(
        "Changing the ETA will update the ETA for all PO lines except for those that are closed, are you sure you want to continue?",
        "Confirm ETA Change",
      );
      if (confirmETAChange) {
        this.defaultDataModel.ETADate = this.model.ETA;

        var dataObj = {
          ETADate: this.defaultDataModel.ETADate,
        };

        // if (this.dataGridViewType == "product-entry") {
        this.dataSourceProductEntry._array.forEach((element) => {
          if (
            element.ItemCode &&
            element.SupplierReceivedQty != element.SupplierRequired
          ) {
            this.dataSourceProductEntry.update(element.ID, dataObj);
          }
        });
        // } else if (this.dataGridViewType == "product-list") {
        this.dataSourceProductList._array.forEach((element) => {
          if (element.ItemCode) {
            this.dataSourceProductList.update(element.ID, dataObj);
          }
        });
        // } else {
        this.dataSourceGLEntry._array.forEach((element) => {
          if (
            element.ItemCode &&
            element.SupplierReceivedQty != element.SupplierRequired
          ) {
            this.dataSourceGLEntry.update(element.ID, dataObj);
          }
        });
        // }

        var dataGrid = this.$refs["dx-data-grid-comp"].instance;
        dataGrid.refresh();
      } else {
        if (!e.previousValue) this.model.ETA = undefined;
        else this.model.ETA = e.previousValue;
        this.defaultDataModel.ETADate = this.model.ETA;
        e.component.beginUpdate();
        e.component.option("value", this.model.ETA);
        e.component.endUpdate();
      }
    },

    setDeliverTo(item, e) {
      if (!e.itemData) return;
      item.DeliveryAddressCompanyName = e.itemData.Description;
      item.DeliveryAddressStreetLine1 = e.itemData.PhysicalAddressStreetLine1;
      item.DeliveryAddressStreetLine2 = e.itemData.PhysicalAddressStreetLine2;
      item.DeliveryAddressSuburb = e.itemData.PhysicalAddressSuburb;
      item.DeliveryAddressState = e.itemData.PhysicalAddressState;
      item.DeliveryAddressPostcode = e.itemData.PhysicalAddressPostcode;
      item.DeliveryAddressCountry = e.itemData.PhysicalAddressCountry;
      item.DeliverTo = e.itemData.Code;

      if (e.component) {
        var component = e.component.instance();
        component.repaint();
      }
    },
    // END

    // Save PO
    async saveTransaction(isValid, brokenRules) {
      const headerToolbarForm = await validationEngine.validateGroup(
        "gc-form-header-toolbar",
      );

      if (!headerToolbarForm.isValid) {
        this.setValidationComeBack("Suppiler");
        isValid = headerToolbarForm.isValid;
        brokenRules = headerToolbarForm.brokenRules.concat(brokenRules);
      }

      if (!isValid) this.displayValidationSummary(brokenRules);
      else if (this.containsManualBatches() && this.model.GoodsReceived) {
        this.addToValidationSum(
          "Items on this Purchase Order have a manual batch method and cannot be received automatically.  Please perform the goods received manually.",
        );
      } else {
        this.savePurchaseOrder(this.model);
      }
    },
    async savePurchaseOrder() {
      if (this.brokenGridValidations.length === 0) {
        if (!this.getPoSavePayload().PurchaseOrderDetails.length) {
          this.addToValidationSum(
            "Purchase Order has no detail. Please add one or more lines before attempting to save the transaction again.",
          );
          return;
        } else {
          this.showLoading(true);
          await PurchaseOrder.savePurchaseOrder(
            this.getPoSavePayload(),
            this.model.Code,
          )
            .then(async (res) => {
              this.showLoading(false);
              if (this.baseView.mode == "create") {
                this.model.Name = undefined;
                this.model.Code = res.data.Code;
              }
              this.$notify(
                `Purchase Order ${this.model.Code} Successfully Saved`,
                "success",
              );
              let destinationMode =
                res.data.NextStatus == "D" ? "edit" : "review";
              this.setIgnoreRouteChangeConfirmation();
              this.reload = true;
              this.loaded = false;
              if (destinationMode == this.baseView.mode) {
                this.refreshView();
                this.beforeInit();
              } else {
                var query = undefined;
                if (this.baseView.query && this.baseView.query.from)
                  query = { from: this.baseView.query.from };

                var POVersion = CommonStorage.getItems(
                  "PurchaseOrderVersionInUse",
                );
                var path = undefined;
                if (POVersion == "V1") {
                  path = "purchase-order";
                } else {
                  path = `purchase-order-${POVersion.toLowerCase()}`;
                }

                this.$router
                  .push({
                    path: `/${path}/${destinationMode}/${this.model.Code}`,
                    query: query,
                  })
                  .then(() => {
                    this.refreshView();
                    this.beforeInit();
                  });
              }
            })
            .catch((error) => {
              this.showLoading(false);
              this.displayServerError(error, "Save purchase order Failed");
            });
        }
      } else {
        let validationMessages = this.brokenGridValidations.map((item) => {
          return `Item : ${
            item.Description
          } has a required quantity of ${this.formatNumber(
            item.RequiredQty,
          )} which is below the received quantity of ${this.formatNumber(
            item.ReceivedQty,
          )}.`;
        });
        this.validationSummary = [];
        var validations = [];
        validationMessages.forEach((element) => {
          validations.push({
            message: element,
          });
        });
        this.displayValidationSummary(validations);
      }
    },

    getPoSavePayload() {
      let payload = {
        Code: this.model.Code,
        DateIn: this.model.DateIn.toSaveDate(),
        GoodsReceived: this.model.GoodsReceived ? "Y" : "N",
        DeliveryAddressCompanyName: this.model.DeliveryAddressCompanyName,
        DeliveryAddressStreetLine1: this.model.DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2: this.model.DeliveryAddressStreetLine2,
        DeliveryAddressSuburb: this.model.DeliveryAddressSuburb,
        DeliveryAddressState: this.model.DeliveryAddressState,
        DeliveryAddressPostcode: this.model.DeliveryAddressPostcode,
        DeliveryAddressCountry: this.model.DeliveryAddressCountry,
        SupplierCode: this.model.SupplierCode,
        ExchangeRate: this.model.ExchangeRate,
        DeliveryInstruction1: this.model.DeliveryInstruction1,
        DeliveryInstruction2: this.model.DeliveryInstruction2,
        Comment1: this.model.Comment1,
        Comment2: this.model.Comment2,
        Comment3: this.model.Comment3,
        Comment4: this.model.Comment4,
        Comment5: this.model.Comment5,
        CurrentStatus: this.model.Status,
        NextStatus: this.model.NextStatus,
        PurchaseOrderDetails: [],
        B2BSupplierReferenceNo: this.model.B2BSupplierReferenceNo,
        DateChanged: this.model.DateChanged
          ? new Date(this.model.DateChanged).toISOString().replace("Z", "")
          : null,
      };

      var reviewDataSource = this.dataSourceReview._array.filter(
        (x) => x.SupplierRequired,
      );

      reviewDataSource.forEach((data) => {
        if (data.ItemCode) {
          let detailObj = {
            BranchCode: data.BranchCode,
            Comment: data.Comment || "",
            DiscPcnt: data.DiscPcnt ? data.DiscPcnt : 0,
            DivisionCode: data.DivisionCode,
            ETADate:
              this.baseView.mode == "create"
                ? data.RequiredByDate.toSaveDate()
                : data.ETADate.toSaveDate(),
            FXPrice:
              !data.LineNo || data.isNewRecord || data.SupplierPriceEdited
                ? data.SupplierFXPrice / data.SupplierConversion
                : data.FXPrice,
            IsVariable: data.IsVariable,
            ItemCode: data.ItemCode,
            ItemType: data.ItemType,
            LineNo: data.isNewRecord ? 0 : data.LineNo,
            Rank: data.Rank,
            RequiredQty: data.RequiredQty,
            RequiredByDate: data.RequiredByDate.toSaveDate(),
            SupplierConversion: data.SupplierConversion,
            SupplierRequired: data.SupplierRequired,
            SupplierUM: data.SupplierUM,
            TaxCode: data.TaxCode ? data.TaxCode : undefined,
            UpdateSupplierPrice: data.UpdateSupplierPrice ? "Y" : "N",
            UpdateStandardCost: data.UpdateSupplierPrice ? "Y" : "N",
          };
          payload.PurchaseOrderDetails.push(detailObj);
        }
      });
      return payload;
    },
    async beforeInit() {
      this.model = { ...modelBase };
      this.loaded = false;
      this.reload = true;
      this.changes = [];
      this.showLoading(true);
      this.dataSourceProductEntry.clear();
      this.dataSourceGLEntry.clear();

      await SettingsService.getBySettingByApplicationFeatureCode(
        "PurchaseOrder",
      ).then((res) => {
        this.screenSettings = res.data.value;
      });

      if (this.baseView.mode !== "create") {
        await PurchaseOrder.getCustomData({
          url: "PurchaseOrderList",
          filter: `Code eq ${this.baseView.id} and (Status ne 'C' and Status ne 'X')`,
          select: ["Code", "GoodsReceived", "Status"],
        }).then((res) => {
          if (res.data.value.length > 0) {
            this.cancelCompleteMenu = [
              {
                menuText: "Complete Order",
                visible: res.data.value[0].GoodsReceived == "Y",
              },
              {
                menuText: "Cancel Order",
                visible: res.data.value[0].GoodsReceived == "N",
              },
              {
                menuText: "Copy",
                visible: this.baseView.mode == "review",
              },
            ];
          } else
            this.cancelCompleteMenu = [
              {
                menuText: "Copy",
                visible: this.baseView.mode == "review",
              },
            ];
        });
      }

      this.reload = false;
      this.initialized();
    },
    async initialized() {
      if (getDefaultUserSettings().BranchCode) {
        this.defaultDataModel.DefaultBranchCode = this.model.BranchCode =
          getDefaultUserSettings().BranchCode;
      } else {
        await BranchService.getDefault().then((res) => {
          this.defaultDataModel.DefaultBranchCode = this.model.BranchCode =
            res.data.value[0].Code;
          this.defaultDataModel.DefaultBranchDescription =
            res.data.value[0].Description;
        });
      }

      if (getDefaultUserSettings().DivisionCode) {
        this.defaultDataModel.DefaultDivisionCode = this.model.DivisionCode =
          getDefaultUserSettings().DivisionCode;
      } else {
        await DivisionService.getDefault().then((res) => {
          this.defaultDataModel.DefaultDivisionCode = this.model.DivisionCode =
            res.data.value[0].Code;
          this.defaultDataModel.DefaultDivisionDescription =
            res.data.value[0].Description;
        });
      }

      if (!this.defaultDataModel.DefaultBranchDescription) {
        let resBranch = await BranchService.getByCode(
          this.defaultDataModel.DefaultBranchCode,
        );
        this.defaultDataModel.DefaultBranchDescription =
          resBranch.data.value[0].Description;

        this.setDeliverTo(this.model, {
          itemData: resBranch.data.value[0],
        });
      }

      if (!this.defaultDataModel.DefaultDivisionDescription) {
        let resDivision = await DivisionService.getByCode(
          this.defaultDataModel.DefaultDivisionCode,
        );
        this.defaultDataModel.DefaultDivisionDescription =
          resDivision.data.value[0].Description;
      }

      this.model.DeliverTo = this.defaultDataModel.DefaultBranchCode;

      if (this.baseView.mode == "create" && !this.baseView.id) {
        await this.$store.dispatch("screenFactors/getFactors", [547, 18, 193]);
        for (let index = 0; index < 1; index++) {
          this.addNewLineIntoProductEntry();

          this.addNewLineIntoGLEntry();
        }
        this.model.NextStatus = getFactorByCode(547).Factorc;
        this.model.DateIn = new Date();
        this.model.Status = "D";
        this.model.Code = 0;

        await CompanyService.getByCompanyCode(getFactorByCode(18).Factorc).then(
          async (res) => {
            this.model.CompanyCurrency = res.data.value[0].CurrencyCode;
            this.model.CurrencyCode = res.data.value[0].CurrencyCode;

            let result = await CompanyCurrencyService.getByCurrencyCode(
              this.model.CurrencyCode,
            );
            this.model.ExchangeRate = result.data.value[0].SellRate;
          },
        );

        this.setFooterItems([]);

        this.model.Name = "Purchase Order";
        this.loaded = true;

        this.showLoading(false);
      } else {
        await this.$store.dispatch(
          "screenFactors/getFactors",
          [547, 18, 193], // , 65, 66]
        );

        await PurchaseOrder.getByCode(this.baseView.id).then((res) => {
          if (res.data.value.length > 0) {
            var data = res.data.value[0];

            this.model = data;

            this.model.SupplierName = data.Supplier.Name;
            this.model.SupplierCode = data.Supplier.Code;
            this.model.DateIn = new Date(data.DateIn);
            this.model.DateChanged = data.DateChanged;

            // - #31312: UI : Update Transaction Screen Template to Support PDF Button
            // - To match ScreenNameToLayout parameter.dataField
            this.model["PurchaseOrder"] = data.Code;
          }
        });

        if (this.baseView.query) {
          if (this.baseView.query.copy == "true") {
            this.model.DateIn = new Date();
            this.model.GoodsIn = undefined;
            this.model.NextStatus = getFactorByCode(547).Factorc;
            this.model.Status = "D";
            this.model.Code = 0;
            this.model.DeliverTo = this.model.DeliveryAddressCompanyName;

            let currency = await ForeignCurrencyService.getByCode(
              this.model.CurrencyCode,
            );

            this.model.ExchangeRate = currency.data.value[0].BuyRate;
          }
        }

        await CompanyService.getByCompanyCode(getFactorByCode(18).Factorc).then(
          async (res) => {
            this.model.CompanyCurrency = res.data.value[0].CurrencyCode;
          },
        );

        this.model.NextStatus = getFactorByCode(547).Factorc;

        let inactiveProducts = [];

        if (this.model.Status == "D" && this.baseView.mode == "review") {
          // force push screen to edit mode when the Sales Order is in Draft mode

          var POVersion = CommonStorage.getItems("PurchaseOrderVersionInUse");
          var path = undefined;
          if (POVersion == "V1") {
            path = "purchase-order";
          } else {
            path = `purchase-order-${POVersion.toLowerCase()}`;
          }
          this.$router
            .push({
              path: `/${path}/edit/${this.model.Code}`,
            })
            .then(() => {
              this.refreshView();
              this.beforeInit();
            });
        } else {
          this.dataSourceReview.clear();
          let record = await PurchaseOrderDetail.getByCode(this.baseView.id);
          if (record && record.data.value.length > 0) {
            var data = record.data.value;
            data.forEach((item) => {
              if (
                this.baseView.mode == "create" &&
                item.ProductInactive == "Y"
              ) {
                inactiveProducts.push(item);
              } else {
                item.ETADate = new Date(item.ETADate);
                item.RequiredByDate = new Date(item.RequiredByDate);

                if (this.baseView.query) {
                  let defaultRequiredByDate = this.model.DateIn
                    ? new Date(this.model.DateIn)
                    : new Date();
                  if (this.baseView.query.copy == "true") {
                    item.RequiredByDate = new Date(
                      defaultRequiredByDate.setDate(
                        defaultRequiredByDate.getDate() + item.SupplierLead,
                      ),
                    );
                    item.SupplierReceivedQty = 0;
                    item.SupplierOutstandingQuantity = item.SupplierRequired;
                    item.ETADate = item.RequiredByDate;
                  }
                }

                if (
                  item.SupplierReceivedQty != 0 &&
                  item.SupplierRequired == item.SupplierReceivedQty
                ) {
                  item.LineGoodsIn = true;
                } else item.LineGoodsIn = false;

                if (item.SupplierReceivedQty > 0) this.model.GoodsIn = true;

                if (item.PurchaseDescription)
                  item.ItemDescription = item.PurchaseDescription;

                item.Code = item.ItemCode;
                item.ProductCode = item.ItemCode;
                item = this.footerValueCalculations(item);

                if (this.baseView.mode != "review") {
                  this.dataGridViewType = "review";
                  if (item.ItemType == "S") {
                    let dataObj = Object.assign(
                      { IsCopyLine: false, IsNewLine: true },
                      item,
                    );
                    this.addNewLineIntoProductEntry(dataObj);
                  }
                  if (item.ItemType == "G") {
                    let dataObj = Object.assign(
                      { IsCopyLine: false, IsNewLine: true },
                      item,
                    );
                    this.addNewLineIntoGLEntry(dataObj);
                  }
                } else {
                  this.dataGridViewType = "review";

                  let maxID = Math.max(
                    ...this.dataSourceReview._array.map((e) => e.ID),
                  );

                  let dataObj = Object.assign(
                    { IsCopyLine: false, IsNewLine: true },
                    item,
                  );

                  if (maxID > 0) dataObj.ID = ++maxID;
                  else dataObj.ID = 1;

                  dataObj.UpdateSupplierPrice =
                    getFactorByCode(193).Factorc == "Y" ? true : false;

                  this.dataSourceReview.insert(dataObj);
                }
              }
            });
          }

          if (this.baseView.mode != "review") {
            // dataSourceProductEntry
            this.addNewLineIntoProductEntry();

            // dataSourceGLEntry
            this.addNewLineIntoGLEntry();

            // this.getPurcharseProductItems();
          }
        }

        if (this.baseView.mode != "review")
          await this.getProductPurchaseList(this.model.SupplierCode);

        this.setFooterItems(this.dataSourceReview._array);

        this.showLoading(false);

        this.loaded = true;

        this.checkBranchSpecs();

        setTimeout(() => {
          if (inactiveProducts.length > 0) {
            this.showInactioveAlert();
          } else {
            if (this.baseView.query) {
              if (this.baseView.query.copy == "true") {
                this.priceUpdateInCopy();
              }
            }
          }
        }, 250);
      }
    },
    async showInactioveAlert() {
      await this.$alert(
        `Purchase Order # ${this.baseView.id} contains lines that are no longer active. These lines will be skipped and will not be added to this Purchase Order`,
        "Warning",
      );
      this.priceUpdateInCopy();
    },
    priceUpdateInCopy() {
      this.$nextTick(function () {
        let myDialog = custom({
          title: "Price Update",
          messageHtml: `Would you like to apply the Purchase Prices from Purchase Order # ${this.baseView.id} or use the current pricing for ${this.model.SupplierName} ?`,
          buttons: [
            {
              text: "Source Pricing",
              onClick: (e) => {
                return { buttonText: e.component.option("text") };
              },
            },
            {
              text: "Current Pricing",
              onClick: (e) => {
                return { buttonText: e.component.option("text") };
              },
            },
          ],
        });
        myDialog.show().then((dialogResult) => {
          if (dialogResult.buttonText == "Current Pricing") {
            this.updateDSPriceForSupplier();
          }
        });
      });
    },
    updateDSPriceForSupplier() {
      this.dataSourceReview._array.forEach((element) => {
        if (element.ItemType == "S") element = this.updateLinePrice(element);
      });

      this.setFooterItems(this.dataSourceReview._array);

      this.dataSourceProductEntry._array.forEach((element) => {
        if (element.ItemType == "S") element = this.updateLinePrice(element);
      });
    },

    updateLinePrice(element) {
      element.SupplierFXPrice = element.CurrentSupplierPrice;
      element.SupplierPriceEdited = true;

      element.FXLineTotal = parseFloat(
        parseFloat(element.SupplierRequired).roundNumber(4) *
          parseFloat(element.SupplierFXPrice).roundNumber(4),
      ).roundNumber(2);

      element.TaxFXLineTotal = parseFloat(
        parseFloat(element.FXLineTotal).roundNumber(2) *
          parseFloat(element.TaxPcnt).roundNumber(2) *
          0.01,
      ).roundNumber(2);

      element.FXIncTaxLineTotal = parseFloat(
        element.FXLineTotal + element.TaxFXLineTotal,
      ).roundNumber(2);

      element.RequiredQty =
        element.SupplierRequired * element.SupplierConversion;

      return element;
    },
    focusCellOnEditMode(dataGrid) {
      var i,
        rowIndex = -1;
      if (this.dataGridViewType == "product-entry") {
        i = this.dataSourceProductEntry._array.findIndex((x) => !x.ItemCode);
        if (i != -1) {
          rowIndex = dataGrid.getRowIndexByKey(
            this.dataSourceProductEntry._array[i].ID,
          );
        }
      } else {
        i = this.dataSourceGLEntry._array.findIndex((x) => !x.ItemCode);
        if (i != -1) {
          rowIndex = dataGrid.getRowIndexByKey(
            this.dataSourceGLEntry._array[i].ID,
          );
        }
      }

      if (rowIndex != -1) this.focusOnEditableCell(rowIndex);
    },
    async getDetailRecord() {
      return await PurchaseOrderDetail.getByCode(this.baseView.id);
    },

    // async setGLChartDataSourceItems() {
    //   let glChartDS = ProductService.dataSourceConfig("api/GLChart", {
    //     filter: this.gLChartDataSourceFilter(),
    //     sort: [{ selector: "ComputedStringCode", asc: true }],
    //     preventPagination: true,
    //   });

    //   this.glChartDataSourceItems = await glChartDS.load();
    // },

    gLChartDataSourceFilter() {
      var data = this.screenSettings.filter(
        (x) => x.SettingName == "FilterAccountType",
      );

      var filter = [["Inactive eq 'N'"]];

      if (data.length > 0) {
        var x = data[0].SettingValue.split(",");
        var fil = [];
        x.forEach((element) => {
          fil.push([`AccountType`, "=", element]);
          fil.push("or");
        });

        if (fil.length > 0) {
          filter.push("and");
          filter.push(fil);
        }
        return filter;
      } else {
        return filter;
      }
    },
    formatNumber(number) {
      return Number(parseFloat(number).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
      });
    },

    setValidationComeBack(key, field) {
      this.validationLineKey = key;
      this.validationDataField = field;
    },
    containsManualBatches() {
      let hasManualBatch = false;

      var items = this.dataSourceGLEntry._array.concat(
        this.dataSourceProductEntry._array,
      );

      for (const item of items) {
        if (item.IsBatchProduct === "Manual") {
          hasManualBatch = true;
          break;
        }
      }

      return hasManualBatch;
    },
    getScreenPath() {
      var POVersion = CommonStorage.getItems("PurchaseOrderVersionInUse");
      var path = undefined;
      if (POVersion == "V1") {
        path = "purchase-order";
      } else {
        path = `purchase-order-${POVersion.toLowerCase()}`;
      }

      return path;
    },
    checkBranchSpecs() {
      var itemsData = [];

      if (this.dataGridViewType == "product-entry") {
        itemsData = this.dataSourceProductEntry._array;
      } else if (this.dataGridViewType == "product-list") {
        itemsData = this.dataSourceProductList._array;
      } else if (this.dataGridViewType == "review") {
        itemsData = this.dataSourceReview._array.filter(
          (x) => x.SupplierFXPrice && x.SupplierRequired,
        );
      } else {
        itemsData = this.dataSourceGLEntry._array;
      }

      var branchCode,
        divisionCode = undefined;
      itemsData.forEach((item) => {
        if (item.ItemCode) {
          if (branchCode) {
            if (branchCode != item.BranchCode) {
              this.model.BranchCode = undefined;
              this.branchPlaceHolder = "Multiple entries specified";
            }
          } else {
            branchCode = item.BranchCode;
            this.model.BranchCode = item.BranchCode;
            this.branchPlaceHolder = "Select";
          }

          if (divisionCode) {
            if (divisionCode != item.DivisionCode) {
              this.model.DivisionCode = undefined;
              this.divisionPlaceHolder = "Multiple entries specified";
            }
          } else {
            divisionCode = item.DivisionCode;
            this.model.DivisionCode = item.DivisionCode;
          }
        }

        this.model.ETA = item.ETADate;
      });
    },
    getAccountSort(SortAccountBy) {
      var data = this.screenSettings.filter(
        (x) => x.SettingName == SortAccountBy,
      );

      if (this.dataViewType == "review") {
        return {
          sortOrder: "asc",
          dataField: "PurchaseDescription",
        };
      } else if (data.length > 0) {
        if (data[0].SettingValue == "AccountDescriptionAsc")
          return {
            sortOrder: "asc",
            dataField: "ParentGLChartDescription",
          };
        else if (data[0].SettingValue == "AccountDescriptionDesc")
          return {
            sortOrder: "desc",
            dataField: "ParentGLChartDescription",
          };
        else if (data[0].SettingValue == "AccountCodeAsc")
          return {
            sortOrder: "asc",
            dataField: "ComputedStringCode",
          };
        else if (data[0].SettingValue == "AccountCodeDesc")
          return {
            sortOrder: "desc",
            dataField: "ComputedStringCode",
          };
        else
          return {
            sortOrder: "asc",
            dataField: "ParentGLChartDescription",
          };
      } else
        return {
          sortOrder: "asc",
          dataField: "ParentGLChartDescription",
        };
    },

    footerValueCalculations(lineData) {
      lineData.TaxFXLineTotal =
        parseFloat(lineData.FXLineTotal).roundNumber(2) *
        parseFloat(lineData.TaxPcnt).roundNumber(2) *
        0.01;

      lineData.FXIncTaxLineTotal = (
        lineData.FXLineTotal + lineData.TaxFXLineTotal
      ).roundNumber(2);

      return lineData;
    },
    getProductSort(SortProductBy) {
      var data = this.screenSettings.filter(
        (x) => x.SettingName == SortProductBy,
      );

      if (data.length > 0) {
        if (data[0].SettingValue == "ProductDescriptionAsc")
          return {
            sortOrder: "asc",
            dataField: "PurchaseDescription1",
          };
        else if (data[0].SettingValue == "ProductDescriptionDesc")
          return {
            sortOrder: "desc",
            dataField: "PurchaseDescription1",
          };
        else if (data[0].SettingValue == "ProductCodeAsc")
          return {
            sortOrder: "asc",
            dataField: "ProductCode",
          };
        else if (data[0].SettingValue == "ProductCodeDesc")
          return {
            sortOrder: "desc",
            dataField: "ProductCode",
          };
        else
          return {
            sortOrder: "asc",
            dataField: "PurchaseDescription1",
          };
      } else
        return {
          sortOrder: "asc",
          dataField: "PurchaseDescription1",
        };
    },
  },
};
</script>

<style lang="scss">
.class-multiple {
  .dx-texteditor-input-container .dx-placeholder,
  .dx-selectbox-container .dx-texteditor-container .dx-placeholder {
    color: black;
  }
}

.gc-state-negative .dx-texteditor-input {
  color: red;
}

.search-products-popup {
  .dx-popup-content {
    padding-top: 0 !important;
  }
}

.purchase-order {
  .gc-grid-footer-left {
    .gc-grid-footer-item.left-content {
      .dx-texteditor-container input {
        text-align: left !important;
      }
    }
  }

  .header-form-container {
    width: 100%;
    display: inline-flex;

    .header-form {
      width: calc((100% / 3) * 2);
      padding-right: 5px;
      margin-bottom: 0 !important;
    }

    .header-comments {
      width: calc((100% / 3) * 1);
      padding-left: 5px;
    }
  }

  .dx-datagrid {
    .comment-text .dx-texteditor-container .dx-texteditor-input-container {
      textarea {
        line-height: unset !important;
        height: inherit !important;
        overflow: auto;
      }
    }

    .comment-cell-template {
      max-height: 103px !important;
      overflow: auto;
    }
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:not(.dx-validation-pending):not(.dx-datagrid-select-all) {
    vertical-align: top !important;
  }
}

.css-v2.gc-popup
  .gc-popup-form.po-dl
  .dx-form
  .dx-item
  .dx-item-content
  .dx-first-col {
  padding-bottom: unset !important;
}
</style>
